export const common = {
  emptyValue: "—",
  a11y: {
    goBack: "Go back",
    loading: "Loading",
    removePhoto: "Remove photo",
    clearSelectedContact: "Clear selected contact",
    selectNamed: "Select {{name}}",
    removeStep: "Remove step",
    removeFilter: "Remove filter",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    removeRelationship: "Remove relationship",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    resetView: "Reset view",
    unlinkContact: "Unlink contact",
    removeCharge: "Remove charge",
    removeLineItem: "Remove line item",
    mapUnavailable: "Map unavailable on this device",
  },
  actions: {
    undo: "Undo",
    cancel: "Cancel",
    keep: "Keep",
    search: "Search",
    takePhoto: "Take photo",
    chooseFromGallery: "Choose from gallery",
    chooseFile: "Choose file",
    dismiss: "Dismiss",
    tryAgain: "Try again",
    saveChanges: "Save changes",
    saving: "Saving…",
  },
  createVerbs: {
    guide: "Guide me",
    inspection: "Start inspection",
    job: "Log job",
    report: "Report issue",
    asset: "Add asset",
    site: "Add site",
    contact: "Add contact",
    share: "Share asset",
    template: "Create checklist",
    recurringJobs: "Maintenance plans",
    document: "Add document",
    meterReading: "Record reading",
    maintenancePlan: "Add maintenance plan",
    knowledge: "Add knowledge",
    relationship: "Add relationship",
    assignAsset: "Assign asset",
    move: "Move asset",
    childSite: "Add child site",
    conditionReport: "Asset report",
    siteReport: "Site 360",
  },
  createNouns: {
    guide: "Guide me",
    asset: "Asset",
    inspection: "Inspection",
    job: "Job",
    report: "Report issue",
    maintenancePlan: "Maintenance",
    contact: "Contact",
    site: "Site",
    template: "Checklist",
  },
  actVerbs: {
    guide: "Guide me",
    inspection: "Inspect",
    job: "Add job",
    report: "Report issue",
    share: "Share",
    document: "Add document",
    meterReading: "Add reading",
    maintenancePlan: "Add plan",
    contact: "Add contact",
    relationship: "Link asset",
    knowledge: "Add article",
    move: "Move",
    conditionReport: "Asset report",
    asset: "Add asset",
    assignAsset: "Assign asset",
    childSite: "Add sub-site",
    siteReport: "Site 360",
  },
  actVerbsA11y: {
    guide: "Guide me through {{name}}",
    inspection: "Start inspection for {{name}}",
    job: "Log job for {{name}}",
    report: "Report issue on {{name}}",
    share: "Share {{name}}",
    document: "Add document to {{name}}",
    meterReading: "Record reading for {{name}}",
    maintenancePlan: "Create maintenance plan for {{name}}",
    contact: "Add contact to {{name}}",
    relationship: "Add relationship for {{name}}",
    knowledge: "Add knowledge to {{name}}",
    move: "Move {{name}}",
    conditionReport: "Generate an asset report for {{name}}",
    asset: "Add asset to {{name}}",
    assignAsset: "Assign asset to {{name}}",
    childSite: "Add child site under {{name}}",
    siteReport: "Site 360 report for {{name}}",
  },
  actionsMenuTitle: "Actions",
  actionGroups: {
    help: "Help",
    work: "Work",
    record: "Record",
    manage: "Manage",
    insight: "Insight",
  },
  createFabA11y: "Create — {{verbs}}",
  capabilityLocked: {
    tryPlanFree: "Try {{plan}} free",
    thisFeature: "This feature",
    notInCurrentPlan: "Not included in your {{plan}} plan",
    notInPlan: "Not included in your plan",
    includedFrom: "Included from the {{plan}} plan",
    includedHigher: "Included in a higher plan",
    internalEdition: "This workspace is on the internal Developer edition. Switch the feature on for Developer in Admin, Matrix.",
    noPlanIncludes: "Not available on any plan at the moment",
    viewPlans: "View plans",
    viewPlansFor: "View plans that include {{feature}}",
    askOwner: "Ask your workspace owner to upgrade.",
    managedOnWeb: "Available on the {{plan}} plan — choose it on Billing & usage.",
    managedOnWebUnnamed: "Plans are chosen on Billing & usage.",
    openBilling: "Open Billing & usage",
    badge: "Upgrade to use",
    betaTitle: "{{name}} is in beta",
    betaDescription: "Join the beta programme to try it early.",
    betaAction: "Request access",
    adminTitle: "{{name}} is turned off",
    adminDescription: "It is turned off for this workspace. Contact AssetWRX support to enable it.",
    dependencyTitle: "{{name}} needs another feature",
    dependencyDescription: "A feature this depends on is turned off. Enable it first.",
    unavailableTitle: "{{name}} is not available",
    unavailableDescription: "This feature is not available for your workspace.",
  },
  kpi: {
    of: "of",
    partial: "partial",
  },
  languageNames: {
    "ar": "العربية",
    "de-DE": "Deutsch (Deutschland)",
    "en-AU": "English (Australia)",
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "es-ES": "Español (España)",
    "fr-FR": "Français (France)",
  },
  createMenuTitle: "Create",
  detailActions: {
    more: "More",
    moreActions: "More actions",
    short: {
      inspect: "Inspect",
      addJob: "Add job",
      issue: "Report issue",
      share: "Share",
      document: "Doc",
      relate: "Relate",
      contact: "Contact",
      insights: "Insights",
    },
    sections: {
      bringWorkIn: "Bring work in",
      doTheWork: "Do the work",
      records: "Records",
      aiAndGuidance: "AI & guidance",
    },
  },
  alerts: {
    errorTitle: "Error",
    requiredTitle: "Required",
    permissionRequiredTitle: "Permission required",
    signInRequiredTitle: "Sign in required",
  },
  labels: {
    id: "ID",
    allTypes: "All types",
    fileSelected: "File selected",
  },
  search: {
    defaultPlaceholder: "Search",
    clear: "Clear search",
  },
  searchableList: {
    searchPlaceholder: "Search…",
    clearSearch: "Clear search",
    all: "All",
    remove: "Remove {{label}}",
    clear: "Clear",
    noMatches: "No matches.",
    more_one: "{{count}} more — refine your search to see it.",
    more_other: "{{count}} more — refine your search to see them.",
  },
  counts: {
    item_one: "{{count}} item",
    item_other: "{{count}} items",
    mappedAssetsShowing_one: "Showing {{count}} mapped asset. {{hidden}} hidden without coordinates.",
    mappedAssetsShowing_other: "Showing {{count}} mapped assets. {{hidden}} hidden without coordinates.",
    itemsCaptureEvidence_one: "{{count}} item currently captures at least one evidence type.",
    itemsCaptureEvidence_other: "{{count}} items currently capture at least one evidence type.",
    importFileSummary: "{{file}} · {{rows}} · {{columns}}",
    importRows_one: "{{count}} data row",
    importRows_other: "{{count}} data rows",
    importColumns_one: "{{count}} column",
    importColumns_other: "{{count}} columns",
    autoMapColumns_one: "Auto-map {{count}} column by name",
    autoMapColumns_other: "Auto-map {{count}} columns by name",
    importPreviewRows_one: "First {{shown}} of {{count}} row. Valid rows show the exact values that will be imported; invalid rows show errors plus the cell values we read.",
    importPreviewRows_other: "First {{shown}} of {{count}} rows. Valid rows show the exact values that will be imported; invalid rows show errors plus the cell values we read.",
    applyRows_one: "Apply {{count}} row",
    applyRows_other: "Apply {{count}} rows",
    automationsReady_one: "{{count}} automation ready",
    automationsReady_other: "{{count}} automations ready",
    aiFollowUpsReady_one: "{{count}} AI-drafted follow-up ready",
    aiFollowUpsReady_other: "{{count}} AI-drafted follow-ups ready",
    extractedItemsFound_one: "{{count}} item found. Edit or untick it before adding it to the job.",
    extractedItemsFound_other: "{{count}} items found. Edit or untick before adding them to the job.",
    addItems_one: "Add {{count}} item",
    addItems_other: "Add {{count}} items",
  },
  teamMemberRole: {
    owner: "Owner",
    admin: "Admin",
    member: "Member",
  },
  teamSummary: {
    memberCount_one: "{{count}} member",
    memberCount_other: "{{count}} members",
    pendingInvites_one: "{{count}} pending invite",
    pendingInvites_other: "{{count}} pending invites",
    expiredInvites_one: "{{count}} expired invite",
    expiredInvites_other: "{{count}} expired invites",
    twoFactorOn: "2FA on",
    twoFactorOff: "2FA off",
    youSuffix: "(You)",
    skillsLoading: "Skills: loading…",
    noSkills: "No skills recorded — tap to add",
    skillCount_one: "{{count}} skill",
    skillCount_other: "{{count}} skills",
    editSkillsA11y: "Edit skills for {{name}}",
  },
  teamMemberAction: {
    askAdmin: "Ask to make admin",
    changeToAdmin: "Change to Admin",
    changeToMember: "Change to Member",
    requestSentTitle: "Request sent",
    requestSentBody: "The team owner will be asked to approve {{name}} as an admin.",
    roleChangeFailed: "Could not change the role",
    removeFailed: "Could not remove the member",
    decideFailed: "Could not save your decision",
    pendingTitle: "Waiting for your approval",
    pendingTitleAdmin: "Waiting for the owner",
    pendingRow: "Make {{name}} an admin? Asked by {{requester}}.",
    approve: "Approve",
    decline: "Decline",
    requestedPill: "Admin requested",
  },
  embedNotice: {
    viewOnly: "View only: this portal lets you look at records, not change them.",
    loading: "Opening AssetWRX…",
    reload: "Reload page",
    expiredBody: "Signing in took longer than this page allows. Reload the page and you will go straight in.",
    expiredTitle: "Reload to continue",
    pageTitle: "Embedded view",
    unsupportedTitle: "Not available here",
    unsupportedBody: "This part of AssetWRX isn't included in this embedded view.",
    goBack: "Go back",
    openInAssetWrx: "Open in AssetWRX",
    unavailableTitle: "Embedding is off",
    unavailableBody: "Embedded AssetWRX is not part of this workspace's plan. Ask your AssetWRX workspace owner about changing the plan.",
    deniedTitle: "Can't open this view",
    deniedBody: "This portal is not allowed to open AssetWRX for you here. Ask your AssetWRX admin to check the embedded app.",
    endedTitle: "Session ended",
    endedBody: "This embedded AssetWRX session has ended. Reload the page to start a new one.",
    sessionRequiredTitle: "Open from your portal",
    sessionRequiredBody: "This AssetWRX view can only be shown by an approved portal. Open it from there.",
    ssoDeniedTitle: "Use your organization's account",
    ssoDeniedBody: "This portal needs you to sign in with your organization's Microsoft account. Reload the page to try again.",
  },
  tourStep: "Step {{current}} of {{total}}",
  guideFlow: {
    pages: {
      assets: "Assets",
      inspections: "Inspections",
      requests: "Requests",
      jobs: "Jobs",
      reports: "Reports",
      contacts: "Contacts",
      contractors: "Contractors",
    },
    ui: {
      open: "Open {{page}}",
      howItWorks: "How it works",
      comesInFrom: "Comes in from",
      feeds: "Feeds {{stage}}",
      tapAgain: "Tap again to open it.",
      subtitle: "The everyday loop, end to end. Hover or tap a stage, then open its page.",
      stageA11y: "{{num}}. {{label}}. {{caption}}. Opens {{page}}.",
      inputA11y: "{{label}}. Feeds {{stage}}. Opens {{page}}.",
    },
    "add-your-first-asset": {
      label: "Add assets",
      caption: "Register what you own",
    },
    "run-an-inspection": {
      label: "Inspect",
      caption: "Check condition & evidence",
    },
    "report-an-issue": {
      label: "Report issues",
      caption: "Anyone flags a problem",
    },
    "create-a-job": {
      label: "Do the work",
      caption: "Commission & track jobs",
    },
    "share-a-report": {
      label: "Review & share",
      caption: "Close the loop",
    },
    "public-intake-qr": {
      label: "Public QR intake",
    },
    "share-for-requests": {
      label: "Shared requesters",
    },
    "add-a-contractor": {
      label: "Contractors",
    },
  },
  notFound: {
    stackTitle: "Not found",
    title: "Page not found",
    goHome: "Go to Home",
    body: "The link may be out of date, or the page has moved.",
  },
  /** lib/formatting/compactDuration.ts — units for rows and chips too narrow for words. */
  compact: {
    minutes: "{{n}}m",
    hours: "{{n}}h",
    days: "{{n}}d",
    now: "now",
    justNow: "just now",
    yesterday: "yesterday",
    tomorrow: "Tmw",
  },
  relative: {
    today: "Today",
    tomorrow: "Tomorrow",
    daysAgo: "{{n}}d ago",
    yesterday: "Yesterday",
    hoursAgo: "{{n}}h ago",
    minutesAgo: "{{n}}m ago",
    justNow: "Just now",
    deadlinePassed: "Deadline passed",
    daysLeft_one: "{{count}} day left",
    daysLeft_other: "{{count}} days left",
    hoursLeft_one: "{{count}} hour left",
    hoursLeft_other: "{{count}} hours left",
    minutesLeft_one: "{{count}} minute left",
    minutesLeft_other: "{{count}} minutes left",
  },
  errors: {
    // lib/errors/dataRequestError.ts (the same English is its default).
    unreachable: "We couldn't reach the server. Check that you're online, then try again.",
    notThrough: "That didn’t go through. Please try again.",
    workspaceUnavailable: "We couldn’t load your workspace. Check that you’re online, then try again.",
    summaryAuthorOnly: "Only the person who carried out this inspection, or a workspace admin, can change its summary, and only until it is signed off.",
    assetNotEditable: "You cannot change one of these assets.",
    templateNotEditable: "You cannot change who this checklist is shared with.",
    deleteApproved: "An approved inspection cannot be deleted; it is part of the compliance record.",
    cancelApproved: "An approved inspection cannot be cancelled.",
    requiredItemsIncomplete: "Every required item needs an answer or a skip before this inspection can be completed.",
    quoteRequestClosed: "This quote request is closed. It has been awarded, has passed its deadline, or was withdrawn.",
    postcheckRequired: "A required check must be completed before this job is submitted.",
    evidenceRequired: "A photo or video of the finished work is required. Add one to this job or to one of its sub-jobs, then try again.",
    precheckRequired: "A precheck must be completed before this job starts.",
    jobHandedOff: "This job has been handed to someone else. Reassign it or take it back to change what it is.",
    jobOutForQuotes: "This job is out with contractors for quotes. Pick a quote or close the request to change what it is.",
    inspectionHandedOff: "This inspection has been handed to someone else. Only they can answer it.",
    retireOpenWork: "This asset still has work in progress. Complete or cancel it before retiring the asset.",
    templateInUseBySchedules: "This checklist is still used by upcoming scheduled inspections. Cancel those schedules first.",
    approveOverseerOnly: "Only the asset’s owner, approver or team can sign off this inspection, and not the inspector on their own work.",
    waiverAdminOnly: "Only a workspace admin can waive a finding.",
    restoreAdminOnly: "Only a workspace admin can restore a retired asset.",
    retireOwnerOrAdmin: "Only the asset’s owner or a workspace admin can retire it.",
    assetRetired: "This asset has been retired and takes no new inspections or jobs.",
    workspaceReadOnly: "This workspace is read-only. Choose a plan in Billing to keep adding and editing.",
    assetPlanLimit: "Your plan’s asset limit has been reached. A larger plan adds more assets.",
    capabilityUnavailable: "This feature is not included in your plan. Choose a plan in Billing to use it.",
    assetSubscriptionRequired: "Your workspace has used the free assets on its plan. Start a subscription to add more assets.",
    assetChanged: "This asset changed since you opened it. Reload it and try again.",
    onlineRequired: "Reconnect to complete this action. Your entered information will remain here.",
    jobUpdateRefused: "This job could not be updated from your account. It may have been reassigned or closed — refresh and try again.",
    jobChanged: "This job changed since you opened it. Reload it and try again.",
    sessionExpired: "Your session has expired. Please sign in again.",
    alreadyExists: "This item already exists. Please use a different value or update the existing one.",
    configMismatch: "The app couldn’t finish this action. Try again, or contact support if it keeps happening.",
    valueNotAllowed: "One of the values is not allowed. Please check your input and try again.",
    network: "Network is slow or offline. Please try again.",
    requiredMissing: "A required field is missing. Please fill in all required information.",
    noPermission: "You don't have permission to do that.",
    missingReference: "Something this action needs has been removed. Refresh and try again.",
    notFound: "That item couldn't be found — it may have been removed.",
    fallback: "Something went wrong. Please try again.",
    generic: "Something went wrong.",
  },
  resilience: {
    capability_disabled: {
      title: "This capability is unavailable",
      body: "Your organisation has not enabled this capability. Contact an administrator if you need access.",
    },
    permission_denied: {
      title: "You do not have permission",
      body: "Your current role cannot perform this action. Your existing work has not been changed.",
    },
    read_only: {
      title: "Read-only access",
      body: "You can view this information, but your current role cannot change it.",
    },
    resource_unavailable: {
      title: "This item is no longer available",
      body: "It may have been removed, or your access may have changed. Open Activity to continue safely.",
      action: "Open activity",
    },
    online_required: {
      title: "Online connection required",
      body: "Reconnect and try again. Any information you entered will remain available on this device.",
    },
  },
  sorting: {
    sortBy: "Sort by",
    newest: "Newest First",
    oldest: "Oldest First",
    last_updated: "Last Updated",
    name_az: "Name A–Z",
    name_za: "Name Z–A",
    priority_high: "Priority High → Low",
    priority_low: "Priority Low → High",
    due_soonest: "Due Soonest",
    due_latest: "Due Latest",
    overdue_first: "Overdue First",
    recently_active: "Recently Active",
    status: "Status",
    condition_score: "Condition Score",
    health_score: "Health Score",
    risk_score: "Risk Score",
    compliance_score: "Compliance Score",
    last_inspection: "Last Inspection Date",
    completed_date: "Completed Date",
    assigned_to: "Assigned To",
    scheduled_date: "Scheduled Date",
    inspection_score: "Inspection Score",
    requested_date: "Requested Date",
    approval_status: "Approval Status",
  },
  scanCapture: {
    openSettings: "Open settings",
    cameraBlockedMessage: "Camera access is turned off for AssetWRX. Turn it on in Settings, or use a photo instead.",
    signInRequiredBody: "Please sign in to read a photo with AI.",
    aiOfflineStatus: "AI reading will be available when you're back online. Your photo is still here.",
    readingWithAiStatus: "Reading the photo with AI…",
    couldNotReadPhotoTitle: "Could not read photo",
    tryAgain: "Please try again.",
    noIdentifierReadable: "No VIN or serial was readable in that photo. Try again or enter it manually.",
    permissionRequiredTitle: "Permission required",
    grantLibraryBody: "Please grant photo library access.",
    readingPhotoStatus: "Reading the photo…",
    couldNotReadOnDeviceWeb: "Enter the value below, or read the photo with AI.",
    couldNotReadOnDeviceNative: "Couldn't read it on this device. Enter the value below, or read the photo with AI.",
    enterAValueTitle: "Enter a value",
    enterAValueBody: "Please paste or type a value.",
    readWithAiLabel: "Read the photo with AI. Costs {{cost}}.",
    readWithAiText: "Read with AI ({{cost}})",
    scanQrTitle: "Scan QR code",
    scanIdentifierTitle: "Scan VIN / Serial",
    webUnavailableMessage: "Camera scanning isn’t available on web. Paste a value, or pick a photo of the label to read it.",
    identifierInputLabel: "VIN or serial number",
    identifierPlaceholder: "Paste or type VIN / serial…",
    useThisValue: "Use this value",
    pickPhotoOfLabel: "Pick a photo of the label",
    requestingCameraPermission: "Requesting camera permission…",
    cameraPermissionRequiredTitle: "Camera permission required",
    cameraPermissionMessage: "Camera access is needed to scan. You can also read a label from a saved photo.",
    grantPermission: "Grant permission",
    usePhotoInstead: "Use a photo instead",
    closeScanner: "Close scanner",
    readingEllipsis: "Reading…",
    positionQrHint: "Position the QR code in the frame",
    positionBarcodeHint: "Point at the barcode, or tap the shutter to read the label from a photo",
    takePhotoOfLabel: "Take a photo of the label",
    photo: "Photo",
    library: "Library",
    holdStill: "Hold still…",
    glareHint: "Glare on the plate — tilt the phone slightly or shade it, then try again.",
    darkHint: "Too dark to read — turn on the light or find better light, then try again.",
  },
  cameraControls: {
    noZoom: "1×",
    zoomPercent: "{{percent}}%",
    zoomOut: "Zoom out",
    zoomIn: "Zoom in",
    resetZoom: "Reset zoom",
    zoomValueA11y: "Zoom {{percent}} percent",
    lightOn: "Turn on the light",
    lightOff: "Turn off the light",
  },
  cookieBanner: {
    title: "Cookies on AssetWRX",
    bodyBeforeLink: "We use cookies that are strictly necessary to run AssetWRX. With your consent, we’ll also use cookies to understand how the app is used and to measure marketing campaigns. You can change your mind any time in",
    bodyCompact: "Necessary cookies only, unless you allow analytics and marketing cookies. Details in the",
    cookiePolicyLink: "Cookie Policy",
    rejectAll: "Reject all",
    managePreferences: "Manage preferences",
    acceptAll: "Accept all",
    preferencesTitle: "Cookie preferences",
    strictlyNecessaryTitle: "Strictly necessary",
    alwaysOn: "Always on",
    strictlyNecessaryBody: "Sign-in, security, and core functionality.",
    analyticsTitle: "Analytics",
    analyticsBody: "Anonymous usage events that help us improve AssetWRX.",
    marketingTitle: "Marketing",
    marketingBody: "Measure campaign performance. We never sell your data.",
    back: "Back",
    savePreferences: "Save preferences",
  },
  analyticsPrompt: {
    title: "Help improve AssetWRX",
    body: "Share usage data (the screens you use and your taps, never what you type) so we can make the app faster and easier. You can change this any time in Account → Privacy & data → Communication preferences.",
    allow: "Allow",
    notNow: "Not now",
  },
  webContactsList: {
    sort: {
      name_asc: "Name A–Z",
      name_desc: "Name Z–A",
      updated_desc: "Recently updated",
    },
    allRoles: "All",
    filterByRoleA11y: "Filter contacts by role",
    roleA11y: "Role: {{role}}",
    moreFiltersA11y: "More filters: all role types and reset",
    more: "More…",
    visibilityScopeA11y: "Visibility scope",
    scopeAllA11y: "Scope: all",
    scopeTeamA11y: "Scope: team",
    scopeAccountA11y: "Scope: account",
    scopeAllLabel: "All scopes",
    scopeTeamLabel: "Team",
    scopeAccountLabel: "Account",
    sortContactsA11y: "Sort contacts",
    sortA11y: "Sort: {{sort}}",
    importContactsA11y: "Import contacts",
    import: "Import",
    columns: {
      name: "Name",
      scope: "Scope",
      roles: "Roles",
      organisation: "Organisation",
      contact: "Email / phone",
      skills: "Skills",
    },
  },
  qrLabelPrint: {
    defaultTitle: "Print QR labels",
    noAssetsTitle: "No assets",
    noAssetsBody: "Select at least one asset to print labels.",
    noQrCodesTitle: "No QR codes",
    noQrCodesBody: "Selected assets do not have QR codes yet.",
    labelsPrepared_one: "{{count}} label prepared.",
    labelsPrepared_other: "{{count}} labels prepared.",
    assetsSkipped_one: "{{count}} asset skipped (missing QR code).",
    assetsSkipped_other: "{{count}} assets skipped (missing QR code).",
    labelsUsedFallback_one: "{{count}} label used the AssetWRX code (no serial on file).",
    labelsUsedFallback_other: "{{count}} labels used the AssetWRX code (no serial on file).",
    labelsReadyTitle: "Labels ready",
    printFailedTitle: "Print failed",
    printFailedBody: "Unable to generate labels.",
    selectedAssetsLabel: "Selected assets",
    selectedAssetsValue_one: "{{count}} selected ({{withQr}} with QR code)",
    selectedAssetsValue_other: "{{count}} selected ({{withQr}} with QR code)",
    templateLabel: "Checklist",
    qrContentsLabel: "QR contents",
    serialCoverageNote: "{{withSerial}} of {{total}} have a serial; the rest fall back to the AssetWRX code.",
    scanActionLabel: "Scan action",
    includeMetadataToggle: "Include short metadata on labels",
    cancel: "Cancel",
    printLabels: "Print labels",
  },
  reportReview: {
    stillToDecide_other: "{{count}} items still need a decision. Read the findings below, then decide in Your decisions above.",
    stillToDecide_one: "{{count}} item still needs a decision. Read the findings below, then decide in Your decisions above.",
    gate: {
      notYouBody: "Tell us how you relate to this asset. The team that manages it decides whether you can see the report.",
      notYouLink: "Not the person it was sent to? Request access",
      useDifferentAccount: "Use a different account",
      signedInAs: "Signed in as {{email}}. This report was sent to a different email address.",
      notYouSignedOut: "Not the person it was sent to? Sign in, then tap Request access.",
      signedOutBody: "Was this sent to you? Sign in with the email address it was sent to and it opens straight away.",
      requestAccess: "Request access",
      sendFailedTitle: "Could not send request",
      roleManager: "Property or managing agent",
      outcomeClear: "No issues found",
      outcomeAttention: "Needs attention",
      outcomeAction: "Action needed",
      askSender: "Ask the person who sent it to send the link again.",
    },
    jobs: {
      count_other: "{{count}} jobs",
      count_one: "{{count}} job",
      estimatedCost: "Est. {{amount}}",
      approvedCost: "Approved {{amount}}",
      started: "Started {{date}}",
      scheduled: "Scheduled {{date}}",
      assignedTo: "Assigned to {{name}}",
      cancelled: "Cancelled: {{n}}",
      inProgress: "In progress: {{n}}",
      completed: "Completed: {{n}}",
    },
    done: {
      senderRepairs_other: "{{count}} repairs approved. Tap Create jobs on the inspection to book them.",
      senderRepairs_one: "{{count}} repair approved. Tap Create jobs on the inspection to book it.",
      repairsApproved_other: "You approved {{count}} repairs. The team is told and can turn them into jobs.",
      repairsApproved_one: "You approved {{count}} repair. The team is told and can turn it into a job.",
      allMarked: "Every item is marked approved. Decline any you don't want, then sign and tap Approve.",
      changesRequested: "You asked for changes. {{company}} has your note.",
      allDeclined: "You approved the report and declined all repairs. The team has your notes.",
      approved: "You approved this report. The team has been told.",
    },
    signOff: {
      decideFirst_other: "Decide each item first ({{count}} left)",
      decideFirst_one: "Decide each item first ({{count}} left)",
      sendBackPlaceholder: "What needs changing? (required)",
      sendBack: "Send back",
      promptDecideFirst: "Tap Approve or Decline on each item above first. You can tap Send back at any time.",
      promptReady: "Sign to sign off. The team is told and can turn the repairs you approved into jobs.",
      promptNoItems: "Read the report. Then sign to sign off, or tap Send back to ask for changes.",
      sendToTeam: "Send to the team",
      signatureLabel: "Sign here",
      recordsOnly: "This report is for your records.",
      changesMessage: "You asked for changes",
      approvedMessage: "You approved this. Thank you.",
      changesPlaceholder: "What needs more work?",
      requestChanges: "Ask for changes",
      approve: "Sign off",
      prompt: "Review the work, then approve it or ask for changes.",
      title: "Your decision",
    },
    insight: {
      itemsIncluded_other: "{{count}} items in this report.",
      itemsIncluded_one: "{{count}} item in this report.",
      senderWaitingItems_other: "Waiting for {{name}} to decide {{count}} items.",
      senderWaitingItems_one: "Waiting for {{name}} to decide {{count}} item.",
      toDecide_other: "{{count}} items need your decision before you approve.",
      toDecide_one: "{{count}} item needs your decision before you approve.",
      sourceLabel: "the items in this report",
      actionSenderWait: "The person who sent it gets a notification when they reply.",
      actionTrackJobs: "Follow the jobs made from this report below.",
      actionApprove: "Sign and tap Approve. The team is told straight away.",
      actionDecide: "Tap Approve or Decline on each item.",
      metricNotDecided: "Not decided",
      metricToDecide: "To decide",
      checkFirst: "Check before you decide: {{list}}.",
      duplicates: "Possible duplicates: {{n}}",
      noPhotos: "No photos: {{n}}",
      urgent: "Urgent: {{n}}",
      decisionCounts: "Approved: {{approved}} · Declined: {{declined}} · Not decided: {{pending}}",
      senderWaiting: "Waiting for {{name}} to approve the report.",
      senderChangesNoReason: "{{name}} asked for changes.",
      senderChanges: "{{name}} asked for changes: “{{reason}}”",
      senderApprovedNoDate: "{{name}} approved this.",
      senderApproved: "{{name}} approved this on {{date}}.",
      nothingToDecide: "Nothing here needs a decision. Read the report, then tap Approve or Send back.",
      youApproved: "You approved this report.",
      youApprovedOn: "You approved this report on {{date}}.",
      titleDone: "Review sent",
      title: "Review summary",
    },
    threadEmptySender: "Message {{name}} here. No messages yet.",
    threadEmptyReviewer: "Ask the inspector a question here. No messages yet.",
    inspector: "Inspector",
    photoA11y: "Photo {{number}} of {{total}} for {{item}}",
    allDecided: "Every item is decided. Sign and tap Approve.",
    decideAbove: "Make your choice in Your decisions above.",
    urgentFlagged: "This item is marked as urgent.",
    urgentNow: "Urgent – needs attention now",
    recommendation: "Recommendation",
    description: "Description",
    ratingType: {
      condition: "Condition",
      level: "Level",
      passFlagFail: "Pass, flag or fail",
      passFailNa: "Pass, fail or N/A",
      yesNo: "Yes or no",
    },
    theirDecisions: "Their decisions",
    reviewerFallback: "The reviewer",
    theTeam: "The team",
    otherGroup: "Other",
    helloGreeting: "Hello {{name}} — {{greeting}}",
    startedOn: "Started {{date}}",
    completedOn: "Completed {{date}}",
    inspectionFallback: "Inspection",
    openAssetA11y: "Open {{name}}",
    metaPill: "Report review",
    notYours: "Only the person this report was sent to can approve it or send it back.",
    saveFailed: "Could not save your choice. Check your connection and try again.",
    evidenceFailed: "Could not load the findings and photos. Check your connection and try again.",
    evidenceTimeout: "The inspection is taking too long to load. Check your connection and try again.",
  },
  jobReportShare: {
    assetFallback: "Asset",
    recipientFallback: "Recipient",
    jobFallback: "Job",
    emailSubject: "Job completion report – {{jobTitle}}",
    headerTitle: "Job completion report",
    shareLinkNotFound: "Share link not found.",
    goToAssetWrx: "Go to AssetWRX",
    signInToViewTitle: "Sign in to view this report",
    signInToViewBody: "This job completion report was shared with your email address. Sign in — or create a free account with that email — and the report will open automatically.",
    signIn: "Sign in",
    createAccount: "Create account",
    noAccessOrNotFound: "Share link not found or you do not have access. If the report was shared with a different email address, sign in with that address to open it.",
    tryAgain: "Try again",
    loadingReport: "Loading report…",
    loadTimeout: "The report is taking too long to load. Check your connection and try again.",
    loadFailed: "Could not load this report.",
  },
  qrScanFallback: {
    linkToExistingAsset: "Link to existing asset",
    title: "QR Code Not Found",
    message: "The scanned QR code \"{{value}}...\" doesn't match any existing asset.",
    createNewAsset: "Create New Asset",
    createNewAssetSubtitle: "Create a new asset and link this QR code to it",
    orLinkToExisting: "Or Link to Existing Asset",
    chooseAssetPlaceholder: "Choose an asset",
    chooseAssetHint: "Choose the asset to link this QR code to",
    linkQrCode: "Link QR Code",
    successTitle: "Success",
    successBody: "QR code linked to asset successfully.",
    errorTitle: "Error",
    linkFailed: "Failed to link QR code.",
  },
  inboxSidebar: {
    openA11y: "Open {{title}}",
    openAction: "Open",
    snoozeFailed: "That did not snooze. Check your connection and try again.",
    snoozedUntil: "Snoozed until {{time}}. It comes back then.",
    groupLabel: {
      high: "Needs you",
      medium: "Updates",
      low: "FYI",
      read: "Read",
    },
    inboxA11y: "Notifications",
    expandInbox: "Show notifications",
    myQueue: "Notifications",
    collapseInbox: "Hide notifications",
    allCaughtUp: "All caught up",
    noActionableNotifications: "You have no actionable notifications.",
    itemsCountA11y_one: "{{title}}, {{count}} item",
    itemsCountA11y_other: "{{title}}, {{count}} items",
    snoozeA11y: "Snooze {{title}}",
    markDoneA11y: "Mark {{title}} done",
    markAllRead: "Mark all read",
    seeAllInMyQueue: "See all notifications",
    seeAll: "See all",
  },
  healthDetail: {
    dismiss: "Dismiss",
    assetHealth: "Asset health",
    close: "Close",
    subtitle: "Operational health is a 0–100 score from compliance documents, inspection schedules and age, open jobs, approvals, and inspection findings. A 1–5 inspection condition rating is measured separately.",
    notScored: "Not scored",
    whatChangedScore: "What changed your score",
    scoreHint: "Each row is the points removed from 100 before the score is capped between 0 and 100.",
    emptyScoreLine: "No score is shown because there are no completed inspections, open jobs, scheduled inspections, compliance documents, or open requests for this asset.",
    noPenaltiesLine: "No penalties from the current rules—score remains at the maximum.",
    flaggedItemsTitle: "Flagged items in latest report",
    openFindingA11y: "Open finding: {{label}}",
    positiveAdjustments: "Positive adjustments",
    recommendedActions: "Recommended actions",
    noActionsLine: "No specific actions—keep inspections and jobs up to date.",
    goTo: "Go to",
    quickLinkJobs: "Jobs",
    quickLinkInspections: "Inspections",
    quickLinkStartInspection: "Start inspection",
    done: "Done",
  },
  contactInvite: {
    invalidLink: "Invalid invitation link",
    invitationNotFound: "Invitation not found",
    invitationExpired: "This invitation has expired",
    invitationInvalid: "This invitation link is no longer valid.",
    failedToLoad: "Failed to load invitation",
    loadTimeout: "The invitation is taking too long to load. Check your connection and try again.",
    emailMismatchTitle: "Email mismatch",
    emailMismatchBody: "This invitation was sent to {{email}}. Please sign in with that email to accept.",
    errorTitle: "Error",
    loadingInvitation: "Loading invitation…",
    invalidOrExpiredTitle: "Invalid or expired",
    tryAgain: "Try again",
    goBack: "Go back",
    title: "Contact invitation",
    descBeforeName: "You've been invited to access the app as",
    descAfterName: ". This links your account to the contact; you won't be added to a team.",
    signInHint: "Sign in to accept this invitation",
    signIn: "Sign in",
    createAccount: "Create account",
    signInWithDifferentEmailHint: "This invite was sent to {{email}}. Sign in with that account.",
    signInWithDifferentAccount: "Sign in with different account",
    accept: "Accept",
  },
  signatureField: {
    defaultLabel: "Signature",
    defaultHelperText: "Tap the box to sign; the pad opens full-screen.",
    clearSignature: "Clear signature",
    clear: "Clear",
    signatureCapturedA11y: "Signature captured — tap to change",
    signed: "Signed",
    tapToChange: "Tap to change",
    openSignaturePadA11y: "Open signature pad to sign",
    tapToSignHere: "Tap to sign here",
    signHereTitle: "Sign here",
    capturedSignatureA11y: "Captured signature",
  },
  invoiceCapture: {
    documentLabelPdf: "PDF",
    documentLabelWord: "Word",
    documentLabelGeneric: "Document",
    permissionRequiredTitle: "Permission Required",
    grantCameraBody: "Please grant camera access to take a photo.",
    grantLibraryBody: "Please grant photo library access.",
    errorTitle: "Error",
    couldNotOpenDocumentPicker: "Could not open document picker.",
    uploadFailedTitle: "Upload failed",
    failedToUploadFile: "Failed to upload file.",
    actionSheetTakePhoto: "Take photo",
    actionSheetChoosePhoto: "Choose photo",
    actionSheetChooseFile: "Choose file (PDF, Word)",
    addInvoiceTitle: "Add invoice",
    addInvoiceBody: "Choose photo or document",
    removeFileTitle: "Remove file",
    removeFileBody: "Are you sure you want to remove this file?",
    remove: "Remove",
    removeInvoiceA11y: "Remove this invoice",
    addInvoiceOrReceiptA11y: "Add invoice or receipt",
  },
  complianceAuditDetail: {
    dismiss: "Dismiss",
    title: "Compliance & audit",
    close: "Close",
    subtitle: "Score reflects documents, inspections, schedules, jobs, and shared approvals. It is a guide, not legal advice.",
    whatsAffectingScore: "What's affecting your score",
    scoreHint: "Each item shows the points applied before the score is capped between 0 and 100.",
    noScoredAdjustments: "No scored adjustments — score is at the baseline (100 before clamping).",
    findingsInLatestReport: "Findings in latest report",
    openFindingA11y: "Open finding: {{label}}",
    positiveSignals: "Positive signals",
    recommendedActions: "Recommended actions",
    noActionsLine: "No specific actions — keep monitoring schedules and documents.",
    automateTitle: "Automatically create renewal work",
    automateBody: "When a certificate or document nears expiry, raise the renewal job and tell the right person.",
    goTo: "Go to",
    quickLinkDocuments: "Documents",
    quickLinkInspections: "Inspections",
    quickLinkJobs: "Jobs",
    done: "Done",
  },
  videoCapture: {
    permissionRequiredTitle: "Permission Required",
    permissionMessage: "Please grant {{type}} access to continue.",
    cameraAccessType: "camera",
    photoLibraryAccessType: "photo library",
    videoTooLongTitle: "Video too long",
    videoTooLongBody: "Videos must be {{max}} seconds or less. This video is {{actual}} seconds.",
    couldNotAddVideoTitle: "Could not add video",
    failedToAddVideo: "Failed to add video. Check your connection and try again.",
    addVideoTitle: "Add Video",
    chooseAnOption: "Choose an option",
    recordVideo: "Record Video",
    chooseFromLibrary: "Choose from Library",
    videoLimitReachedTitle: "Video limit reached",
    videoLimitReachedBody_one: "You can attach up to {{count}} video here. Remove one to add another.",
    videoLimitReachedBody_other: "You can attach up to {{count}} videos here. Remove one to add another.",
    removeVideoTitle: "Remove Video",
    removeVideoBody: "Are you sure you want to remove this video?",
    playVideoA11y: "Play video {{index}}",
    videoPreviewA11y: "Video {{index}} preview",
    videoLabel: "Video {{index}}",
    removeVideoA11y: "Remove video {{index}}",
    addVideoLabel: "Add Video",
  },
  signatureCaptureModal: {
    defaultHelperText: "Sign with your finger or mouse, then tap Done.",
    cancelSigningA11y: "Cancel signing",
    saveSignatureA11y: "Save signature",
    done: "Done",
  },
  conversationThread: {
    defaultEmptyHint: "No messages yet. Start the conversation.",
    updates: "Updates",
    updatesWithName: "Updates with {{name}}",
    earlier: "Earlier",
    earlierA11y: "Earlier 100 messages",
    newer: "Newer",
    newerA11y: "Newer 100 messages",
    latest: "Latest",
    latestA11y: "Latest messages",
    loadingMessages: "Loading messages…",
    messagesUnavailable: "Messages are unavailable right now.",
    noMessagesInThisPart: "No messages in this part of the conversation.",
    startAnUpdatePlaceholder: "Start an update…",
    messageA11y: "Message",
    sendMessageA11y: "Send message",
    couldNotSendMessage: "Could not send message.",
    failedToSend: "Failed to send",
  },
  guideArticle: {
    userGuideTitle: "User guide",
    helpTitle: "Help",
    articleNotFound: "Article not found",
    whyItMatters: "Why it matters",
    showMe: "Show me",
    howToDoIt: "How to do it",
    whatToDoNext: "What to do next",
  },
  webQuickCreateMenu: {
    quickCreateA11y: "Quick create",
    quickCreate: "Quick create",
  },
  ownershipTransfer: {
    aTeamMemberFallback: "a team member",
    couldNotUpdateTitle: "Could not update the transfer",
    tryAgain: "Please try again.",
    doneTitle: "Done",
    offerLapsesSuffix: " The offer lapses on {{date}}.",
    offeredOwnershipTitle: "You have been offered ownership of {{teamName}}",
    offeredOwnershipBody: "{{initiatorName}} wants to hand the team over to you. As owner you manage members, billing and workspace settings; {{initiatorName2}} becomes an admin.",
    acceptOwnership: "Accept ownership",
    nowOwnTeam: "You now own {{teamName}}.",
    decline: "Decline",
    declinedOffer: "You declined the offer.",
    waitingForAcceptTitle: "Waiting for {{targetName}} to accept ownership",
    waitingForAcceptBody: "Nothing changes until they accept. You stay the owner meanwhile.",
    cancelOffer: "Cancel offer",
    offerWithdrawn: "The offer was withdrawn.",
  },
  routeError: {
    title: "This screen hit a problem",
    body: "The rest of the app is still running and your queued offline work is safe. Try again, or go back and reopen this screen.",
    referenceLabel: "Reference: {{referenceId}}",
    tryAgain: "Try again",
    goBack: "Go back",
  },
  photoAttachButton: {
    couldNotAddPhotoTitle: "Could not add photo",
    pleaseTryAgain: "Please try again.",
    permissionRequiredTitle: "Permission Required",
    permissionMessage: "Please grant {{type}} access to continue.",
    cameraAccessType: "camera",
    photoLibraryAccessType: "photo library",
    addPhotoTitle: "Add photo",
    addPhotoBody: "Add the photo as-is, or draw to highlight areas first.",
    addNow: "Add now",
    photoAdded: "Photo added",
    drawToHighlight: "Draw to highlight",
    addPhotoOptionsTitle: "Add Photo",
    chooseAnOption: "Choose an option",
    camera: "Camera",
    photoLibrary: "Photo Library",
    attachPhotoA11y: "Attach photo",
  },
  qrResolver: {
    lookupTimedOut: "QR lookup timed out.",
    resolvingQrCode: "Resolving QR code...",
    scannedAssetTitle: "You scanned an asset",
    scannedAssetBody: "This code belongs to an asset managed in AssetWRX. Choose what you'd like to do.",
    scannedAssetBodySignInOnly: "This code belongs to an asset managed in AssetWRX. Sign in to see it.",
    reportAnIssue: "Report an issue",
    reportAnIssueA11y: "Report an issue on this asset — no account needed",
    signInToView: "Sign in to view",
    signInToViewA11y: "Sign in to view this asset",
  },
  teamSwitcher: {
    teamFallback: "Team",
    personal: "Personal",
    switchTeam: "Switch team",
    cancel: "Cancel",
  },
  requiredSkillsPicker: {
    defaultLabel: "Skills required",
    couldNotLoad: "Could not load skills right now.",
    couldNotRefresh: "Could not refresh skills. Try again.",
    requiredTitle: "Required skills",
    skillsTitle: "Skills",
    requiredHint: "Select one or more skills. At least one is required.",
    optionalHint: "Select one or more skills from your catalog (optional).",
    mustHaveTag: " · must have",
    removeSkillA11y: "Remove {{name}}",
    changeRequiredSkills: "Change required skills",
    selectAtLeastOne: "Select at least one required skill",
    addSkillsOptional: "Add skills (optional)",
    mandatoryHint: "Mark a skill “Must have” and anyone without it is not offered for this work. The rest just rank higher.",
    searchSkillsA11y: "Search skills",
    searchSkillsPlaceholder: "Search skills...",
    loadingSkills: "Loading skills...",
    noSkillsFound: "No skills found yet. Add skills in Contractor settings.",
    noSkillsMatch: "No skills match your search.",
    removeSkillRowA11y: "Remove {{name}}",
    addSkillRowA11y: "Add {{name}}",
    mustHaveOnA11y: "{{name}} is a must-have. Make it a preference instead.",
    mustHaveOffA11y: "Make {{name}} a must-have for this work",
    mustHave: "Must have",
    done: "Done",
  },
  reportingPage: {
    executiveSummary: "Executive summary",
    supportingDetail: "Supporting detail",
    whatChanged: "What changed",
    whyItMatters: "Why it matters",
    action: "Action",
    hideReportStatements: "Hide report statements",
    showReportStatements: "Show report statements and supporting rows",
    sourceLabel: "this report's records",
  },
  refineSheet: {
    defaultTitle: "Refine",
    activeFilters_one: "{{count}} active filter",
    activeFilters_other: "{{count}} active filters",
    noActiveFilters: "No active filters",
    reset: "Reset",
    doneA11y: "Done",
    done: "Done",
  },
  qrCodeDisplay: {
    noQrCode: "No QR code available",
    copyErrorTitle: "Error",
    copyErrorBody: "Failed to copy QR code link.",
    shareMessageWithName: "Asset QR Code for {{name}}: {{url}}",
    shareMessageNoName: "Asset QR Code: {{url}}",
    copied: "Copied",
    copyLink: "Copy Link",
    share: "Share",
  },
  jobCard: {
    urgencyLow: "Low",
    urgencyMedium: "Medium",
    urgencyHigh: "High",
    urgencyCritical: "Critical",
    scheduledFallback: "Scheduled",
    dueDate: "Due {{date}}",
    createdToday: "Created today",
    createdDate: "Created {{date}}",
    rejectedFallback: "Rejected",
    rejectedWithReason: "Rejected: {{reason}}",
    unassigned: "Unassigned",
    newUpdate: "New update",
    updatedAt: "Updated {{when}}",
    skillCount_one: "{{count}} skill",
    skillCount_other: "{{count}} skills",
    a11yJob: "Job: {{title}}",
    a11yAsset: "Asset: {{name}}",
    a11yStatus: "Status: {{status}}",
    a11yPriority: "Priority: {{priority}}",
    a11yCategory: "Category: {{category}}",
    a11yAssignee: "Assignee: {{name}}",
    a11ySchedule: "Schedule: {{when}}",
    a11yActivity: "Activity: {{activity}}",
    a11yAttentionOverdue: "Attention: Overdue",
    a11yAttentionUnscheduled: "Attention: Unscheduled",
    openAssetA11y: "Open asset {{name}}",
    detailsFallback: "details",
    noAsset: "No asset",
    followOnPending: "Follow-on pending",
    overdue: "Overdue",
    unscheduled: "Unscheduled",
    followOnPendingApproval: "Follow-on · Pending approval",
    priorityColumnHint: "Priority",
    assigneeColumnHint: "Assignee",
    dueScheduleColumnHint: "Due / schedule",
    typeColumnHint: "Type",
  },
  healthCard: {
    assetHealth: "Asset Health",
    noInspectionsYet: "No inspections yet",
    viewOpenJobsInWork: "View open jobs in Work",
    startInspectionInWork: "Start inspection in Work",
    viewHealthBreakdown: "View health breakdown",
    lastInspected: "Last inspected {{date}}",
  },
  failedSyncRecovery: {
    defaultTitle: "Could not sync",
    dismiss: "Dismiss",
    copyError: "Copy error",
    retrySync: "Retry sync",
  },
  conflictResolution: {
    title: "Someone else changed this inspection",
    body: "Someone else saved this inspection while some of your answers were waiting to save. Your answers stay on this device until you choose.",
    mergeAndSync: "Keep my answers",
    useLatestFromServer: "Use theirs",
    hint: "Use theirs removes your unsaved answers from this device.",
    decideLater: "Decide later",
  },
  evidenceCapture: {
    defaultDocumentSectionLabel: "Documents",
    media: "Media",
    addPhotoOrVideoA11y: "Add a photo or video",
    addPhotoA11y: "Add a photo",
    addVideoA11y: "Add a video",
    noMediaAttached: "No media attached",
    hintPhoto_one: "Up to {{count}} photo",
    hintPhoto_other: "Up to {{count}} photos",
    hintVideoWithPrefix_one: "Up to {{count}} video",
    hintVideoWithPrefix_other: "Up to {{count}} videos",
    hintVideoNoPrefix_one: "{{count}} video",
    hintVideoNoPrefix_other: "{{count}} videos",
    hintVideoDurationSuffix: ", max {{seconds}}s",
    addEvidence: "Add evidence",
    takeAPhoto: "Take a photo",
    chooseAPhoto: "Choose a photo",
    recordAVideo: "Record a video",
    chooseAVideo: "Choose a video",
  },
  localComplianceRead: {
    clearRead: "Clear read",
    checkThis: "Check this",
    confirm: "Confirm",
    certificateNumber: "Certificate number",
    nextDue: "Next due",
    result: "Result",
    readingOnDevice: "Reading the document on this device…",
    useCertificateNumber: "Use certificate number {{value}}",
    useNextDueDate: "Use next due date {{value}}",
    title: "Read from this document",
    dismissA11y: "Dismiss the document read",
    readOnDeviceNoCredits: "Read on this device — no AI credits used.",
    use: "Use",
  },
  planPicker: {
    trial: "Try free for {{days}} days, then {{price}}",
    adds: "Adds {{list}}",
    titleLimit: "Upgrade to add more",
    titleChange: "Choose your plan",
    titleUnlock: "Unlock {{feature}}",
    checkoutFailedTitle: "Unable to start checkout",
    introLimit: "Choose a plan to add more assets and unlock more features. Any free period you have left carries over.",
    introChange: "Your plan sets which features are available. Assets and AI credits are billed separately.",
    loading: "Loading plans…",
    unavailable: "Plans could not be loaded. Try again later.",
    notNow: "Not now",
    current: "Current",
    yourPlan: "Your plan",
    payFor: "Pay for {{name}}",
    renew: "Renew {{name}}",
    priceFree: "Free",
    priceTalkToUs: "Talk to us",
    priceFromPerAsset: "From {{price}}/asset/mo",
    priceFeePlusAssets: "{{price}}/mo + per asset",
    priceFeeOnly: "{{price}}/mo",
    priceAnnualPlusAssets: "{{price}}/yr + per asset",
    priceAnnualOnly: "{{price}}/yr",
    continueWith: "Continue with {{name}}",
    contactSales: "Contact sales",
    managedOnWeb: "Not available to buy in the app",
    otherPlans: "Other plans",
    webOnly: "Plans and credits are chosen on Billing & usage.",
  },
  storePlans: {
    title: "Subscribe in the app",
    loading: "Loading plans…",
    unavailable: "Subscriptions are not available right now. Try again later.",
    perMonth: "{{price}} a month",
    perYear: "{{price}} a year",
    subscribe: "Subscribe",
    working: "Working…",
    restore: "Restore purchases",
    activating: "Activating your plan…",
    pending: "Your purchase went through. Your plan will update in a moment. Tap Refresh on Billing & usage.",
    manage: "Manage subscription",
    billedElsewhere: "This workspace’s subscription is billed outside this app.",
    termsIos: "Payment is charged to your Apple ID when you confirm. The subscription renews automatically unless it is cancelled at least 24 hours before the end of the current period. Manage or cancel it in your App Store account settings.",
    termsAndroid: "Payment is charged to your Google account when you confirm. The subscription renews automatically unless it is cancelled before the end of the current period. Manage or cancel it in Google Play subscriptions.",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
  },
  planLimit: {
    title: "Plan limit reached",
    subscriptionRequiredTitle: "Plan limit reached",
    nextAssetNeedsPlan: 'You have used the free assets on your plan. The next one needs a paid plan.',
    assetsUsed: '{{used}} of {{limit}} assets on your plan.',
    checkoutUnavailableTitle: 'Checkout is not available here yet',
    checkoutUnavailableBody: 'Plans cannot be bought from this build. Contact us and we will set it up for you.',
    memberBodyCreate: "Your workspace is at its plan's asset limit. A workspace admin must choose a plan before another active asset can be added.",
    memberBodyImport: "Your workspace is at its plan's asset limit. A workspace admin must choose a plan before more assets can be imported.",
    notNow: "Not now",
    seePlans: "See plans",
    perAsset: "Per asset",
    limit: "Asset limit: {{count}}",
  },
  /** Field sync states (lib/fieldSync/contract.ts is the English contract; a test keeps en-US equal to it). */
  fieldSync: {
    local_draft: {
      label: "Saved locally",
      message: "Saved on this device — it'll sync automatically once you're back online.",
    },
    pending_sync: {
      label: "Syncing",
      message: "Syncing your changes…",
    },
    synced: {
      label: "Synced",
      message: "All changes synced.",
    },
    failed_sync: {
      label: "Needs attention",
      message: "Couldn't save that change — your work is safe on this device. Tap to retry.",
      messageWithDetail: "Couldn't save: {{detail}} Tap to retry.",
    },
    conflict_review: {
      label: "Needs attention",
      message: "Someone else updated this — take a quick look before saving.",
    },
    online_required: {
      label: "Online required",
      message: "Reconnect to complete this action. Your entered information will remain here.",
    },
  },
  editionPlanSection: {
    contactSalesTitle: "Contact sales",
    contactSalesBody: "Email {{email}} to discuss the {{plan}} plan.",
    notSet: "Not set",
    customPricing: "Custom pricing",
    noCharge: "No charge",
    changePlan: "Change plan",
    chooseAPlan: "Choose a plan",
    changeTitle: "Switch to {{name}}?",
    changeBody: "A bigger plan starts now, and the difference for the rest of this billing period is charged today. A smaller plan, or Free, starts at your renewal date; until then nothing changes.",
    scheduledTitle: "Plan change booked",
    scheduledBody: "Your plan changes to {{name}} on {{date}}. Until then you keep what you have. Choose your current plan again to cancel the change.",
    changeConfirm: "Switch",
    changeCancel: "Not now",
    billMonthly: "Monthly",
    billYearly: "Yearly",
    billingTerm: "Billing",
  },
  legalDoc: {
    unknownDocument: "Unknown document.",
    loadFailed: "This document could not be loaded. Please try again shortly.",
    versionLabel: "Version {{version}}",
    effectiveLabel: "Effective {{date}}",
    titleFallback: "Legal",
    loading: "Loading…",
    errorTitle: "Error",
    documentNotFound: "Document not found.",
  },
  notificationRecovery: {
    title: "Notification",
    safeRecovery: "Safe recovery",
  },
  actionSheet: {
    cancelA11y: "Cancel",
    cancel: "Cancel",
  },
  actionPopover: {
    closeCreateMenuA11y: "Close create menu",
  },
  fieldModeToggle: {
    fieldModeA11y: "Field mode",
    fieldModeHint: "Raises contrast and touch targets for outdoor use",
    fieldMode: "Field mode",
  },
  appErrorBoundary: {
    title: "Something went wrong",
    body: "AssetWRX captured the failure. You can retry this screen without losing queued offline work.",
    retry: "Retry",
  },
  profileAvatar: {
    profileAvatarA11y: "Profile avatar",
    profileInitialsA11y: "Profile initials",
  },
  nativeDateTimePicker: {
    selectDate: "Select date",
    selectTime: "Select time",
    cancelSelectionA11y: "Cancel {{mode}} selection",
    cancel: "Cancel",
    confirmA11y: "Confirm {{mode}}",
    done: "Done",
  },
  assetMapView: {
    basemapStreets: "Streets",
    basemapSatellite: "Satellite",
    basemapTopographic: "Topographic",
    overlayClusters: "Cluster grouping",
    overlayHeatmap: "Density heatmap",
    overlaySelectionHighlight: "Selection highlight",
    threeDCameraTilt: "3D camera tilt",
    threeDTerrainRelief: "3D terrain relief",
    hideMapOptionsA11y: "Hide map options",
    basemapA11y: "Basemap: {{name}}",
    mapOptionsA11y: "Map options",
    rendererUnavailable: "Map renderer unavailable on this device.",
  },
  uiCopy: {
    checkAnswerNotSavedTitle: "Couldn’t save that answer",
    checkLoadFailed: "Couldn’t load this check.",
    fieldAssist: {
      tryAgain: "Please try again.",
      revert: "Revert",
      discard: "Discard",
      accept: "Accept",
      suggestedTitle: "Suggested text",
      dictate: "Dictate",
      stop: "Stop",
    },
    markAllNotificationsAsRead_2777a0: "Mark all notifications as read",
    retrySearch_eed38a: "Retry search",
    importAssetsFromSpreadsheet_319028: "Import assets from spreadsheet",
    filterBySite_cf1cee: "Filter by site",
    couldntLoadYourAssets_9878ab: "Couldn’t load your assets",
    yourAssetsAreStillThereCheckYour_f01439: "Your assets are still there. Check your connection and try again.",
    loadingRelationshipView_b7eaea: "Loading relationship view…",
    noMappedAssetsYet_6f573a: "No mapped assets yet.",
    saveCoordinatesOnAnAssetToEnable_da096f: "Save coordinates on an asset to enable map view.",
    mapUnavailableRightNow_d6091e: "Map unavailable right now.",
    theAssetListStillWorksNormally_b8aeb7: "The asset list still works normally.",
    loadingMap_8f267a: "Loading map…",
    assignSite_e1d79b: "Assign site",
    assignToSite_5f6e86: "Assign to site",
    contactInsight_51a9e3: "Contact insight",
    findContactsSkills_f8dc04: "Search contacts",
    refineContactFilters_fa9072: "Refine contact filters",
    importContactsFromAFileOrYour_210d87: "Import contacts from a file or your device",
    refineContacts_982f6f: "Refine contacts",
    opensFiltersToChangeWhichContactsAre_304ff8: "Opens filters to change which contacts are shown.",
    chooseAContactToSeeSharedAssets_8202a6: "Choose a contact to see shared assets, requests, and related work without leaving this page.",
    noContactDetailsOnFile_131e9d: "No contact details on file",
    noLinkedSkills_16d322: "No linked skills",
    noOpenJobsForThisContact_4857c4: "No open jobs for this contact",
    historyNotes_83ccc2: "History & notes",
    couldntRefreshYourWorkShowingWhatWas_8e2372: "Couldn't refresh your work — showing what was last loaded. Tap to retry.",
    generateAdvancedReport_7e5def: "Generate advanced report",
    buildsAFullReportUsingInspectionsJobs_bfa133: "Builds a full report using inspections, jobs, documents, risk data, maintenance history, and optional internet research.",
    advancedReportInsight_a02085: "Advanced report insight",
    noAdvancedReportGeneratedYet_59d1d4: "No advanced report generated yet.",
    fillInDetailsToSeeAPreview_84bd8b: "Fill in details to see a preview here.",
    assetNameRequired_06d7dc: "Asset name (required)",
    suggestedIdentity_36046f: "Suggested identity",
    dismissIdentitySuggestion_f3e055: "Dismiss identity suggestion",
    identifyTheAssetTypeFromThePhoto_d205fa: "Identify the asset type from the photo using AI",
    identifiedFromPhoto_c90812: "Identified from photo",
    applyTheIdentifiedAssetType_a066ab: "Apply the identified asset type",
    applyType_00972d: "Apply type",
    dismissPhotoIdentity_a1052e: "Dismiss photo identity",
    inServiceToday_7a4392: "In service today?",
    yesInUse_0e9408: "Yes, in use",
    notYet_8de95f: "Not yet",
    qRCodeWillBeLinkedAfterCreation_87a9e9: "QR code will be linked after creation",
    matchMyNearestSite_4d4d97: "Match my nearest site",
    tapToAddYourFirstPhoto_7f8b7c: "Tap to add your first photo",
    gallery_9c30a3: "Gallery",
    removeAllPhotos_6c3c73: "Remove all photos",
    iDSerialOptional_25584f: "ID / Serial (optional)",
    thisReferenceLinksIoTDevicesAndAPI_4f5ce4: "This reference links IoT devices and API events to this asset.",
    scanIDOrSerial_956e65: "Scan ID or serial",
    readFromPhoto_ee811f: "Read from photo",
    relationshipsOptional_df493d: "Relationships (optional)",
    vehicleType_964438: "Vehicle type",
    fuelType_0e58d4: "Fuel type",
    usage_0bb186: "Usage",
    propertyType_8ad7ea: "Property type",
    occupancy_570235: "Occupancy",
    equipmentType_d92829: "Equipment type",
    powerSource_56547a: "Power source",
    installation_c81b79: "Installation",
    whereIsThisAssetInItsLife_ffff43: "Where is this asset in its life?",
    criticalityOptional_491f40: "Criticality (optional)",
    howCriticalIsThisAssetToOperations_04df20: "How critical is this asset to operations?",
    operatingContextOptional_178f94: "Operating context (optional)",
    complianceTagsOptional_2df1fc: "Compliance tags (optional)",
    identifyAndTag_f946d5: "Identify and tag",
    addMoreNowOrAnytimeLater_3eac61: "Add more now, or anytime later.",
    potentialDuplicatesDetected_4b9918: "Potential duplicates detected",
    moreOptions_0a1b2c: "More options",
    reviewMatchingAssetsBeforeCreatingANew_90559b: "Review matching assets before creating a new record.",
    useExistingAsset_3f06d4: "Use existing asset",
    openExisting_941fb8: "Open existing",
    continueAnyway_011856: "Continue anyway",
    createLinkPossibleDuplicate_e5dcab: "Create + link possible duplicate",
    markIntentionallyDistinct_cc3540: "Mark intentionally distinct",
    subtype_a729bb: "Kind of document",
    loadingAsset_a104a6: "Loading asset",
    retryLoadingAsset_544af8: "Retry loading asset",
    onlyTheAssetsOwnerOrItsTeam_95113f: "Only the asset's owner or its team can edit it. You can still view it and raise work against it.",
    basicDetails_42450f: "Basic details",
    photosOptional_c0ea6e: "Photos (optional)",
    removeAllPhotos_1329e0: "Remove All Photos",
    egToyotaCamry2024_d36609: "e.g. Toyota Camry 2024",
    locationNotes_259645: "Location & notes",
    addDetailsAboutThisAsset_ec093a: "Add details about this asset...",
    identifiers_649d28: "Identifiers",
    importAssets_9158f1: "Import assets",
    invalidSharedAssetLink_1f7b4c: "Invalid shared asset link.",
    sharedAsset_80c5e0: "Shared asset",
    checkingAccess_c5108c: "Checking access…",
    signInWithTheAccountThatWas_5dd47c: "Sign in with the account that was invited as a contact to continue directly to this shared asset.",
    signInToViewThisSharedAsset_c8d337: "Sign in to view this shared asset",
    createAnAccountToViewThisShared_bef153: "Create an account to view this shared asset",
    couldNotCheckAccess_c29580: "Could not check access",
    accessNotAvailable_7c84ab: "Access not available",
    thisShareIsntLinkedToYourAccount_305fbe: "This share isn’t linked to your account yet, or the owner has revoked access. If you just accepted an invite, refresh to try again.",
    backToAssets_caff2b: "Back to assets",
    refreshAccess_822875: "Refresh access",
    thisAssetIsNotSharedWithYour_76b685: "This asset is not shared with your linked contact, or the share was created for a different contact record.",
    shareDeclined_292608: "Share declined",
    youPreviouslyDeclinedAccessToThisAsset_d9ccbb: "You previously declined access to this asset.",
    acceptSharedAsset_79b229: "Accept shared asset",
    declineSharedAsset_6908ef: "Decline shared asset",
    sharedBy_a5fe3b: "Shared by",
    youaposllBeAbleToView_bc03b3: "You'll be able to view",
    acceptToViewThisAssetWithThe_8df15c: "Accept to view this asset with the access above, or decline to remove the invitation.",
    assetdetail_27a5fa: "asset-detail",
    templateName_0a8669: "Checklist name *",
    templateNameRequired_5db301: "Checklist name (required)",
    selectOneOrMore_1489f2: "Select one or more",
    updateChecklist_fce28f: "Update checklist",
    editChecklist_8c20d6: "Edit checklist",
    inspectionObjective_6129b6: "Inspection objective *",
    describeWhatYouWantToInspectEg_1fb338: "Describe what you want to inspect (e.g. Pre-purchase vehicle check, safety and mechanical condition).",
    egPrepurchaseVehicleCheckSafetyAndMechanical_871268: "e.g. Pre-purchase vehicle check, safety and mechanical condition",
    inspectionObjective_ce4266: "Inspection objective",
    categories_1c14ef: "Categories *",
    assetOptional_95db78: "Asset (optional)",
    selectAnAsset_9dd87a: "Select an asset",
    inspectionDepth_2b1225: "Inspection depth",
    targetDurationMinutesOptional_fe3727: "Target duration (minutes, optional)",
    targetDurationInMinutes_1897b3: "Target duration in minutes",
    evidenceMode_e83c42: "Evidence mode",
    optimizeForSpeed_56e47b: "Optimize for speed",
    optimizationFocusOptional_0ebfbe: "Optimization focus (optional)",
    failonlyEvidenceFocusKeepsEvidenceModeOn_1f0e17: "Fail-only evidence focus keeps evidence mode on fail-only capture.",
    baseTemplateOptional_d80914: "Base checklist (optional)",
    preferToBuildItYourselfCreateManually_ae612e: "Prefer to build it yourself? Create manually",
    draftSetup_a9804f: "Draft Setup",
    guidance_b5e0b5: "Guidance",
    useThisWorkspaceToIterateObjectiveDuration_76a28d: "Say what you inspect and why. AI drafts the checklist; you check and change it before anything is saved.",
    baseTemplate_54f2a3: "Base checklist",
    generatingTemplateDraft_8fdb48: "Generating checklist draft…",
    thisMayTakeAMoment_2cd85b: "This may take a moment.",
    buyUsageCredits_a49d2e: "Buy usage credits",
    templateName_954ab9: "Checklist name",
    draftRationaleAndWarnings_0ce71c: "Draft rationale and warnings",
    groupsItems_9bcc66: "Groups & items",
    draftSummary_4e141c: "Draft Summary",
    warnings_1430f9: "Warnings",
    reviewDraft_6a9bff: "Review draft",
    editThenSaveOrDiscard_f1ef70: "Edit then save or discard",
    inspectionreport_04aa89: "inspection-report",
    createARecurringJob_4a519d: "Create a maintenance plan",
    newRecurringJob_dcc457: "New maintenance plan",
    couldntLoadRecurringJobs_cbd362: "Couldn't load maintenance plans",
    noRecurringJobsYet_c5a4c5: "No maintenance plans yet",
    openCurrentJob_cf8169: "Open current job",
    end_a2bb9d: "End",
    jobreport_c30f90: "job-report",
    pleaseWaitFinalisingYourSubscription_9839a5: "Please wait — finalising your subscription.",
    openPrivacyAmpData_453313: "Open Privacy & data",
    retryLoadingYourWorkspace_be5137: "Retry loading your workspace",
    signInToViewThisQuoteRequest_317846: "Sign in to view this quote request",
    thisInviteWasSentToYourEmail_d77859: "This invite was sent to your email address. Sign in — or create a free account with that email — and the quote request will open automatically.",
    retryLoadingQuoteInvitation_7c3b72: "Retry loading quote invitation",
    ifTheInviteWasSentToA_2463c0: "If the invite was sent to a different email address, sign in with that address to open it.",
    retryLoadingQuoteContext_2406e9: "Retry loading quote context",
    loadingQuoteDetailsAndSavedDraft_3c2a11: "Loading quote details and saved draft",
    requestDetails_bf5023: "Request details",
    additionalContextFromClient_1d46de: "Additional context (from client)",
    yourQuote_756213: "Your quote *",
    yourQuoteRequired_afd50e: "Your quote (required)",
    durationEstimateOptional_ace4e9: "Duration estimate (optional)",
    availabilityWindowOptional_9e64b7: "Availability window (optional)",
    materialsIncluded_5ffbdc: "Materials included",
    materialsDetails_72ea3e: "Materials details",
    details_4dade5: "Details...",
    warrantyOptional_010797: "Warranty (optional)",
    eg12Months_0ff628: "e.g. 12 months",
    additionalDetails_04831c: "Additional details...",
    attachmentsOptional_106896: "Attachments (optional)",
    loadingInspection_1ad221: "Loading inspection…",
    whatTheInspectionFound_b53913: "What the inspection found",
    avgCondition_6b3737: "Avg Condition",
    needsDecision_229276: "Needs decision",
    inspectorNotes_2f7e20: "Inspector Notes",
    recommendedRepair_a70281: "Recommended Repair",
    labourMaterials_08ee77: "Labour & Materials",
    estimatedCost_35caa4: "Estimated Cost",
    jobsFromThisReport_fa5fee: "Jobs from this report",
    tapAJobToSeeFullDetails_fe7c8c: "Tap a job to see full details and status.",
    couldNotSyncReview_375861: "Could not sync review",
    inspectionreview_077ff2: "inspection-review",
    acceptTeamInvitation_2f956c: "Accept team invitation",
    acceptInvitation_f41d2a: "Accept Invitation",
    declineTeamInvitationForNow_7ce799: "Decline team invitation for now",
    yourTeams_d63712: " Your teams",
    createNewTeam_a8d9ef: "Create new team",
    addTeam_046c3a: "Add team",
    noTeam_178b88: "No Team",
    createATeamToCollaborateInviteContractors_bf3947: "Create a team to collaborate, invite contractors, and assign jobs.",
    createTeam_8d826c: "Create team",
    createTeam_8b8973: "Create Team",
    giveYourTeamAName_0161ea: "Give your team a name",
    teamName_9b11ed: "Team name",
    egAcmeInspections_60df82: "e.g. Acme Inspections",
    newTeam_7ff544: "New team",
    searchMembers_bdad23: "Search members…",
    searchMembers_a1d97a: "Search members",
    usedToMatchWorkToPeopleA_4d8242: "Used to match work to people. A job can mark a skill &ldquo;must have&rdquo;, and anyone without it is not offered for it.",
    makeOwner_f99257: "Make owner",
    resetTwofactor_4efb84: "Reset two-factor",
    removeMember_1c31d1: "Remove member",
    closeMenu_6c9fc9: "Close menu",
    invitations_4b0b9f: " Invitations",
    workspaceMembershipGrantsAppAccessContactRecords_e5c34b: "Workspace membership grants app access. Contact records stay separate and can be linked to work without becoming members.",
    inviteANewTeamMember_52559c: "Invite a new team member",
    invitePeople_e1eb97: "Invite people",
    emailAddressesForInvitationsOnePerLine_5e7e7e: "Email addresses for invitations, one per line",
    addOneOrMoreAddressesSeparatedBy_162bd6: "Add one or more addresses, separated by a new line or comma.",
    whatShouldTheyBeAbleToDo_224294: "What should they be able to do?",
    cancelInviteForm_156d89: "Cancel invite form",
    noPendingInvitations_8d0735: "No pending invitations",
    showMeHowToInviteAMember_6b43bc: "Show me how to invite a member",
    showMeHowToInviteSomeone_61b6a4: "Show me how to invite someone",
    teamSettings_373140: " Team settings",
    workspaceDefaultsAccount_4ae7a6: "Workspace defaults (account)",
    baselineDefaultsForTheWorkspaceYouCan_f78072: "Baseline defaults for the workspace. You can also set these in Account → Settings if you're not in a team.",
    workspaceCommunication_2c579b: "Workspace communication",
    teamOverrides_4c6f5e: "Team overrides",
    overrideThisTeamOrKeepItInheriting_1d3b9a: "Override this team, or keep it inheriting workspace defaults.",
    teamCurrencyMode_f9eea7: "Team currency mode",
    inheritWorkspace_879a54: "Inherit workspace",
    override_842192: "Override",
    teamCommunicationMode_d0ba75: "Team communication mode",
    effectiveDefaultsInThisContext_3905f8: "Effective defaults in this context",
    onlyWorkspaceOwnersAndAdminsCanChange_325bf7: "Only workspace owners and admins can change these defaults.",
    openWorkspaceAIAndAutomationAudit_f2fd0f: "Open workspace AI and automation audit",
    workspaceAIAutomationAudit_79db57: "Workspace AI & automation audit",
    renameTeam_bbd28e: "Rename team",
    leaveTeam_b445f9: "Leave team",
    transferOwnership_a6819e: "Transfer ownership",
    deleteTeam_a9661e: "Delete team",
    chooseAMemberToOfferOwnershipTo_ee74d9: "Choose a member to offer ownership to. They must accept; you then become an admin.",
    input_b568d4: "Input",
    plainlanguageGuideForThisTrigger_546a3a: "Plain-language guide for this trigger",
    whatYouCanPassToAnotherSystem_3385b2: "What you can pass to another system",
    sendingDataOutTypicalWebhookStep_9fa855: "Sending data out (typical webhook step)",
    fixedPartReplaceTheExampleWebAddress_b73594: "Fixed part — replace the example web address with yours",
    automaticPartFilledFromThisTriggerWhen_a65fba: "Automatic part — filled from this trigger when the recipe runs",
    optionalFiltersAbove_b7c00b: "Optional filters (above)",
    trigger_56cc41: "trigger.",
    trigger_082e86: "trigger.…",
    advancedRecipeBuilder_799724: "Advanced recipe builder",
    fullTriggerConditionAndStepControlFor_c176d8: "Full trigger, condition, and step control for power users. Prefer Guided for new automations when a template fits.",
    triggerCatalog_b27d78: "Trigger catalog",
    actionCatalog_44816c: "Action catalog",
    howToCreateARecipe_18bda4: "How to create a recipe",
    recipesConnectATriggerWhenToOne_9c1ff3: "Recipes connect a trigger (when) to one or more actions (what). Nothing runs in production until you activate the draft from the list on the right.",
    recipeWizard_6830a5: "Recipe wizard",
    buildADraftBelowThenActivateIt_219398: "Build a draft below, then activate it from the Recipes list.",
    syncCompletedInspectionsToCRM_2594a7: "Sync completed inspections to CRM",
    optionalInternalNote_dedb5c: "Optional internal note",
    triggerType_a8b3dc: "Trigger type",
    chooseWhenThisRecipeShouldRunOptions_065235: "Choose when this recipe should run. Options are grouped by topic; the short code under each name is an optional reference if you map fields from another system.",
    selectedTrigger_4573c4: "Selected trigger",
    intervalMinutes_617c3f: "Interval minutes",
    conditionsOptional_d2f0fb: "Conditions (optional)",
    onlyRunWhenTheIncomingEventMatches_c87bd3: "Only run when the incoming event matches every row you add. Use short field names from your source system (for example status or id on the record). Leave empty to run every time this trigger fires.",
    jSONPath_a8136f: "JSON path",
    dataobjectstatus_f2b5ba: "data.object.status",
    value_8dce17: "Value",
    completedOrOpenpaused_f935e5: "completed or [\"open\",\"paused\"]",
    addCondition_42fe69: "Add condition",
    noFiltersEveryMatchingTriggerRunsThe_5cdf5e: "No filters — every matching trigger runs the actions.",
    actionsRunInOrder_dd55c2: "Actions (run in order)",
    pickWhatEachStepShouldDoThen_8b8ac5: "Pick what each step should do, then paste or edit the JSON. Use the gray box under your trigger for copy-ready examples and rename fields to match your other software.",
    actionType_fece43: "Action type",
    fixedValuesJSON_3002d2: "Fixed values (JSON)",
    valuesFromTheEventJSON_11f1b5: "Values from the event (JSON)",
    urltriggerdatawebhookcallbackUrl_24747a: "{\"url\":\"trigger.data.webhook.callbackUrl\"}",
    addAction_2824f0: "Add action",
    stableKeysScopesSchemasSamplesAndConnector_a9453b: "Stable keys, scopes, schemas, samples, and connector hints for external builders.",
    zapier_569964: "Zapier",
    powerAutomate_81fa07: "Power Automate",
    queuedSkippedSucceededAndFailedRecipeRuns_ceb06e: "Queued, skipped, succeeded, and failed recipe runs with manual retry.",
    noRunsHaveBeenRecordedYet_cfe5db: "No runs have been recorded yet.",
    importAssetsOrContactsFromACSV_8bb4c4: "Import assets or contacts from a CSV or Excel file. Map columns, preview validation, then create records.",
    fileIntegrationHealth_2a85ee: "File integration health",
    credentialsScopeRunsUnderYourSignedinWorkspace_7e301a: "Credentials / scope: runs under your signed-in workspace permissions; file contents are mapped before records are created.",
    chooseACsvOrXlsxFileThe_d63529: "Choose a .csv or .xlsx file. The first row must contain column headers.",
    chooseFileToImport_7450d5: "Choose file to import",
    whatAreYouImporting_15be02: "What are you importing?",
    startOver_51dd91: "Start over",
    mapColumnsAndOptionalDefaults_b4665a: "Map columns and optional defaults",
    flowFileObjectTypeAssetscontactsThisStep_1f9978: "Flow: file → object type (assets/contacts) → this step → Preview (validation) → Import. Here, pick which column in your spreadsheet feeds each app field. If a column is missing or cells are empty, set a default below — it fills every row where that value is missing. Fields marked * need a column or a default. Preview shows row-level problems (e.g. subtype not valid for that row’s asset type) before anything is saved.",
    browseAllowedSubtypeValuesByAssetType_a490ea: "Browse allowed subtype values by asset type",
    browseAllowedSubtypeValuesByAssetType_580a2c: "Browse allowed subtype values (by asset type)",
    sameFieldsAsWhenYouAddAn_66723f: "Same fields as when you add an asset from the Assets tab (quick create).",
    sameToplevelFieldsAsAssetDetailsSubtype_f2742b: "Same top-level fields as Asset → Details (subtype, criticality, and tag lists). Structured option-set JSON is not imported here — use plain text and allowed tag values listed in the reference above.",
    sameAsAddContactWhoThisRecord_ba62a1: "Same as Add contact — who this record represents.",
    whoCanSeeThisContactDefaultRoles_144799: "Who can see this contact; default roles if the file has none.",
    defaultIfEmpty_4d3688: "Default if empty",
    optionalUseForEveryRowWhenBlank_6bd308: "Optional: use for every row when blank",
    oneDefaultSubtypeAppliesToEveryRow_1adca0: "One default subtype applies to every row with an empty subtype cell. If your file mixes asset types, that value must be valid for all of them — usually use a Subtype column instead.",
    whenAMatchingRecordAlreadyExists_2bc530: "When a matching record already exists",
    updateMatchingRecords_acbd0a: "Update matching records",
    matchAssetsByExternalIDAndContacts_440e6c: "Match assets by external ID and contacts by email.",
    skipMatchingRecords_c0ae31: "Skip matching records",
    leaveExistingAssetWRXRecordsUnchanged_8f82ad: "Leave existing AssetWRX records unchanged.",
    everyRowHasOneExplicitActionValidation_3af4e8: "Every row has one explicit action. Validation errors will not be written.",
    dataToImport_06e654: "Data to import",
    valuesReadFromFileThisRowWill_bd4d2f: "Values read from file (this row will not import)",
    noNonemptyFieldsOnThisRow_33c6ae: "No non-empty fields on this row.",
    noMappedValuesForThisRow_b90088: "No mapped values for this row.",
    importFinished_c3e89b: "Import finished",
    created_05e8fd: "Created ",
    andMore_c2145e: "…and more",
    importAnotherFile_6dc962: "Import another file",
    closeSubtypeReference_be22c0: "Close subtype reference",
    subtypeValuesImport_0c957e: "Subtype values (import)",
    useTheCodeOrLabelInThe_0a2125: "Use the code or label in the Subtype column. The value must match the asset type on the same row (or your type default).",
    connected_3dfd4d: "connected.*",
    connectedruleexecuted_594141: "connected.rule.executed",
    temperature_7033e9: "temperature",
    xApiKey_cef935: "X-Api-Key",
    httpspartnerexamplecomhooksassetwrx_79a38c: "https://partner.example.com/hooks/assetwrx",
    jobId_f3d2e2: "jobId",
    status_48a366: "status",
    title_3c6de1: "title",
    tESTASSET001_6a6a4b: "TEST-ASSET-001",
    opsCopilot_5a267c: "Ops copilot",
    httpsmcpexamplecom_a938f2: "https://mcp.example.com",
    httpsexamplecomwebhooksassetwrx_fc61e9: "https://example.com/webhooks/assetwrx",
    retryTestConnection_c9f32a: "Retry test connection",
    refreshLogs_f970c3: "Refresh logs",
    credentialAndScopeClarity_6593d1: "Credential and scope clarity",
    assistantAccessStillRequiresWorkspaceEnablementPlus_df3128: "Assistant access still requires workspace enablement plus per-tool/resource approval in the catalog.",
    retryConnectionTest_4382ef: "Retry connection test",
    whatThisWizardSetsUp_ced2db: "What this wizard sets up",
    thisExposesAssetWRXItselfAsAFirstparty_a9b397: "This exposes AssetWRX itself as a first-party MCP server for the current workspace. External MCP clients get workspace-scoped reads and proposal-first write tools through the backend only.",
    assetWRXSystemConnector_bbcfee: "AssetWRX system connector",
    thisAssistantConnectorIsAlwaysAvailableFor_6e5481: "This assistant connector is always available for the workspace, hidden from normal users, and cannot be removed.",
    whatYouGet_8ac7aa: "What you get",
    proposalfirstWritesAuditHistoryAndPerworkspaceEnablement_4086cb: "Proposal-first writes, audit history, and per-workspace enablement.",
    readsExposedInV1_a02d0c: "Reads exposed in v1",
    workspaceSummaryDashboardStatusAssetsInspectionsJobs_ac16ca: "Workspace summary, dashboard status, assets, inspections, jobs, checklists, and assistant context reads where safe.",
    builtinAssistantCapabilities_e47a5d: "Built-in assistant capabilities",
    writeBehaviorInV1_73d808: "Write behavior in v1",
    materialToolsCreateProposalsFirstNothingCommits_9951b2: "Material tools create proposals first. Nothing runs until an owner or admin approves it here (they are notified), unless the owner lets that action run without approval; the client then calls `confirm_proposed_action`.",
    enableWorkspaceExposure_3b8aed: "Enable workspace exposure",
    turnOnTheEndpointConfirmTheWorkspace_c9acbe: "Turn on the endpoint, confirm the workspace status, and set how long write proposals stay valid before they expire.",
    endpoint_92ec63: "Endpoint",
    proposalTTLMinutes_b08405: "Proposal TTL (minutes)",
    validRange5To1440MinutesDefault_81859c: "Valid range: 5 to 1440 minutes. Default: 30 minutes.",
    approveToolsAndResources_6e4769: "Approve tools and resources",
    keepOnlyTheWorkspacesafeMCPSurfaceYou_433b1d: "Keep only the workspace-safe MCP surface you want external clients to see. Disabled rows are hidden from `tools/list` and `resources/list`.",
    noFirstpartyMCPToolsAreRegisteredYet_a45543: "No first-party MCP tools are registered yet.",
    noFirstpartyMCPResourcesAreRegisteredYet_58e317: "No first-party MCP resources are registered yet.",
    serviceaccountKeysAndScopes_8f39e0: "Service-account keys and scopes",
    thisWizardDoesNotMintSecretsDirectly_ba8449: "This wizard does not mint secrets directly. External MCP clients must use existing workspace service-account API keys created in API keys & access.",
    requiredScopeModel_206642: "Required scope model",
    readsRequireMcpreadPlusTheRelevantDomain_efecc5: "Reads require `mcp:read` plus the relevant domain read scope such as `assets:read`.",
    writeProposalsRequireMcpinvokePlusTheRelevant_bde894: "Write proposals require `mcp:invoke` plus the relevant write scope such as `jobs:write`.",
    proposalConfirmationAndCancellationStayBoundTo_b8a213: "Proposal confirmation and cancellation stay bound to the same workspace and requesting key.",
    clientSetupExample_dde719: "Client setup example",
    safetyDefaults_f1e85c: "Safety defaults",
    neverHandOutUnlessTheClientIs_26c700: "Never hand out `*` unless the client is fully trusted. Prefer read-only keys first, then separate proposal-capable keys for controlled automations.",
    reviewProposalsAndAuditHistory_945ebe: "Review proposals and audit history",
    useThisStepToConfirmExternalClients_209a95: "Use this step to confirm external clients are only reading the intended resources and that material actions remain proposal-first and auditable.",
    proposalHistory_0f9af9: "Proposal history",
    noFirstpartyMCPProposalsYet_62c81f: "No first-party MCP proposals yet.",
    mcpProposalApprove: "Approve",
    mcpProposalDecline: "Decline",
    mcpProposalDecideFailed: "Couldn't record the decision",
    mcpAwaitingApprovalTitle: "Waiting for your approval ({{count}})",
    mcpAwaitingApprovalHint: "An AI assistant asked to make these changes. Nothing happens until you approve; declined or expired requests never run.",
    mcpApproveAll: "Approve all ({{count}})",
    mcpDeclineAll: "Decline all ({{count}})",
    mcpApproveAllConfirmTitle_one: "Approve {{count}} request?",
    mcpApproveAllConfirmTitle_other: "Approve {{count}} requests?",
    mcpApproveAllConfirmBody: "Every \"{{action}}\" request waiting here is approved, and the AI can then run each one.",
    mcpDeclineAllConfirmTitle_one: "Decline {{count}} request?",
    mcpDeclineAllConfirmTitle_other: "Decline {{count}} requests?",
    mcpDeclineAllConfirmBody: "None of the \"{{action}}\" requests waiting here will run.",
    mcpShowAll: "Show all {{count}}",
    mcpShowFewer: "Show fewer",
    mcpApprovalRequired: "Approval required",
    mcpApprovalNotRequired: "Runs without approval",
    mcpWaiveApprovalTitle: "Let “{{name}}” run without approval?",
    mcpWaiveApprovalBody: "An AI assistant can then make this change without an owner or admin approving it. You can switch approval back on at any time.",
    mcpWaiveApprovalConfirm: "Run without approval",
    mcpApprovalUpdateFailed: "Couldn't change approval for this action.",
    invocationAudit_06c951: "Invocation audit",
    noFirstpartyMCPInvocationHistoryYet_352e60: "No first-party MCP invocation history yet.",
    assetWRXMCPExposure_b699b4: "AssetWRX MCP exposure",
    exposeThisWorkspaceAsAFirstpartyMCP_7fae12: "Expose this workspace as a first-party MCP server with workspace-scoped reads, proposal-first writes, and audit history.",
    firstpartySetup_16908a: "First-party setup",
    loadingAssetWRXMCPExposure_4cc589: "Loading AssetWRX MCP exposure...",
    loadingAssetWRXMCPExposure_ec357e: "Loading AssetWRX MCP exposure…",
    workspaceControls_3cfefd: "Workspace controls",
    useServiceaccountKeysWithMcpreadForResources_d8fd58: "Use service-account keys with `mcp:read` for resources and `mcp:invoke` plus domain write scopes for proposal-capable tools.",
    exposedTools_50a475: "Exposed tools",
    materialActionsStayProposalfirstEvenWhenEnabled_40b9b8: "Material actions stay proposal-first even when enabled here.",
    exposedResources_420463: "Exposed resources",
    resourceTemplatesStayWorkspacescopedAndAreFiltered_664498: "Resource templates stay workspace-scoped and are filtered by service-account scopes.",
    hideMoreActions_dd5915: "Hide more actions",
    hideActions_affb29: "Hide actions",
    showMoreActions_2ff0fa: "Show more actions",
    searching_ba2b5a: "Searching...",
    aICanDraftThisRepairJob_247024: "AI can draft this repair job",
    why_d77989: "Why?",
    autoprepFollowupJobsAndScheduleTighteningSuggested_8be7b7: "Auto-prep, follow-up jobs, and schedule tightening suggested",
    reviewAutomations_a7cc10: "Review automations",
    workingOnThisText_24726e: "Working on this text...",
    acceptIndividuallyOrInBulkEachWrites_bf195f: "Accept individually or in bulk — each writes the draft to the matching item below.",
    scheduledDate_b41cf0: "Scheduled date",
    selectADate_642b09: "Select a date",
    chooseAssignee_3f1566: "Choose assignee",
    searchRequests_f13d82: "Search requests",
    noRequestsMatchYourSearch_a6c94d: "No requests match your search.",
    reportResponsePending_44c9b7: "Report response pending",
    completionReviewPending_b4145c: "Completion review pending",
    confirmDate_14424a: "Confirm date",
    confirmTheScheduledDate_b2fc2c: "Confirm the scheduled date",
    requestADifferentTime_0d7d3e: "Request a different time",
    cancelRequest_84837a: "Cancel request",
    cancelThisRequest_f56a63: "Cancel this request",
    preferredDate_921625: "Preferred date",
    sendTheRescheduleRequest_b5dc9f: "Send the reschedule request",
    cancelTheRescheduleRequest_9fb111: "Cancel the reschedule request",
    chooseNextAction_94f5b9: "Choose next action",
    chooseAWorkPathTheRequestDetails_804dd3: "Choose a work path; the request details stay prefilled for confirmation, assignment, and timing.",
    recommended_9ef937: "Recommended",
    createWorkFromRequest_47ff21: "Create work from request",
    confirmOwnerDueDatePriorityAndInstructions_8bc8fe: "Confirm owner, due date, priority, and instructions before creating the job",
    inspectRequest_5569d2: "Inspect request",
    chooseStartNowAssignOrScheduleAfter_c334b8: "Choose start now, assign, or schedule after confirming checklist and scope",
    whoApprovesWorkOnThisAsset_2e42d2: "Who approves work on this asset?",
    inspectionConditionTrend_179a6f: "Inspection condition trend",
    searchNameCompanyRole_baab25: "Search name, company, role",
    tryClearingTheSearchOrFilters_0818c7: "Try clearing the search or filters.",
    roleCompany_feef85: "Role · Company",
    changeAccess_fec7d5: "Change access",
    overdueWorkDocumentRiskAndOpenInspection_66d5d1: "Overdue work, document risk, and open inspection state.",
    noUrgentItemsRightNow_d3111a: "No urgent items right now.",
    responsibleTeam_fd5898: "Responsible team",
    approvesWork_3d9f4c: "Approves work",
    signsOffInspectionsAndJobCompletionsAnd_35b573: "Signs off inspections and job completions, and validates documents.",
    draftInProgress_82d43c: "Draft & in progress",
    healthComplianceAndRiskAreScoredFrom_3c3736: "Health, compliance and risk are scored from the full record and shown to the asset's owner and team.",
    noDocumentsMatchTheCurrentFilters_193238: "No documents match the current filters.",
    noDocumentDatesThisMonth_01f2cb: "No document dates this month.",
    noDocumentsOnThisDay_ed643f: "No documents on this day.",
    plannedRunsWorkInFlightAndCompleted_12c7f2: "Planned runs, work in flight, and completed reports for this asset.",
    startAnInspectionToEstablishConditionAnd_5e3ce5: "Start an inspection to establish condition and follow-up work.",
    completedCancelledInspections_118586: "Completed & cancelled inspections",
    scheduledActiveAndClosedWorkTiedTo_bdec69: "Scheduled, active, and closed work tied to this asset.",
    noJobsForThisAsset_778118: "No jobs for this asset",
    createFollowupWorkForThisAssetWhen_346e1d: "Create follow-up work for this asset when something needs action.",
    completedCancelledJobs_9dae91: "Completed & cancelled jobs",
    searchKnowledge_42cfc4: "Search knowledge",
    addToKnowledge_52f38f: "Add to knowledge",
    publicIntake_b9f61c: "Public intake",
    turnThisOnToGetAQR_7dd031: "Turn this on to get a QR code and link anyone can use to report an issue on this asset — no account or sign-in needed.",
    publicIntakeQRCode_71844b: "Public intake QR code",
    howItWorks_1dd6a1: "How it works",
    "1PrintOrDisplayThisQRCode_b4b58b": "1. Print or display this QR code on or near the asset.",
    "2AnyoneScansItWithTheirPhone_399e27": "2. Anyone scans it with their phone camera — no app or login.",
    "3TheyDescribeTheIssueAndIt_0cf748": "3. They describe the issue and it lands in your requests.",
    printThisQRCode_355b08: "Print this QR code",
    printQR_3d3e5d: "Print QR",
    copyIntakeLink_d55587: "Copy intake link",
    printOrShareTHISCodeItsThe_081cb8: "Print or share THIS code — it's the only one that works without an account. The asset's own QR label opens the asset for signed-in team members and will ask an outsider to log in.",
    publicIntakeIsOnButThisApp_37c7e6: "Public intake is on, but this app build has no public web address to point the QR code at, so there is no link to share yet. It is set at build time (EXPO_PUBLIC_WEB_APP_URL) — ask whoever produced this build to configure it. The web app is unaffected.",
    closePublicIntake_83ee14: "Close public intake",
    clearFilter_b667d6: "Clear filter",
    retire_c9714c: "Retire",
    cancelRetiring_021841: "Cancel retiring",
    thisAssetIsStillInServiceTake_6d33c8: "This asset is still in service. Take it out of service first — then retire the record.",
    decommissionThisAssetFirst_3dba4e: "Decommission this asset first",
    decommissionFirst_449932: "Decommission first",
    whyIsItBeingRetired_424b30: "Why is it being retired?",
    anythingTheRecordShouldSayEgReplaced_39f4f8: "Anything the record should say — e.g. replaced by unit B-12.",
    retirementNote_69e12e: "Retirement note",
    disposalOptional_664c05: "Disposal (optional)",
    recipientBuyerScrapYardLessor_bc1312: "Recipient — buyer, scrap yard, lessor",
    disposalRecipient_0bcdb7: "Disposal recipient",
    disposalValue_7e69e8: "Disposal value",
    whatHappens_d208fd: "What happens",
    retireThisAsset_843886: "Retire this asset",
    editSharedAccess_874a55: "Edit shared access",
    canRequestWorkLetsThemSubmitInspection_66303c: "\"Can request work\" lets them submit inspection or job requests; \"Can view\" is read-only. Both can see jobs and inspections.",
    documentsArePrivateByDefaultTurnThis_f79dc7: "Documents are private by default. Turn this on to let them download the asset's files.",
    canDownloadDocuments_d483c0: "Can download documents",
    thisContactIsNotLinkedToAn_cfbe9b: "This contact is not linked to an app user yet. Save will share the asset, but they must accept a contact invite before they can see it in the app.",
    relationshipToThisAsset_cc572f: "Relationship to this asset",
    moreRelationships_1c2d3e: "More relationships",
    howThisContactIsLinkedOnThe_b75d5d: "How this contact is linked on the asset record (org / tenancy). Select one or more relationships.",
    whatThisContactCanDoInThe_1f7b90: "What this contact can do in the shared asset workspace. \"Can request work\" lets them submit inspection or job requests; \"Can view\" is read-only. Both can see jobs and inspections.",
    saveShare_bcf6ed: "Save share",
    qR_45e7a1: "QR",
    scanOrPrintLabelsForThisAsset_c3fdde: "Scan or print labels for this asset.",
    print_5b221e: "Print",
    qRCodeWillBeGeneratedWhenAsset_31ea4e: "QR code will be generated when asset is saved",
    assetIntelligence_d0cf4b: "Asset intelligence",
    conditionNotRatedYet: "Condition not rated yet · needs an inspection",
    why_21e2ca: "Why",
    keepTheCurrentSchedule_ade385: "Keep the current schedule",
    keepCurrentSchedule_24ceb0: "Keep current schedule",
    operationalReadiness_f83f30: "Operational readiness",
    noReadinessChecksCurrentlyNeedAttention_8a0ffe: "No readiness checks currently need attention",
    foundations_2efa1e: "Foundations",
    topCommandsForThisAsset_43db45: "Top commands for this asset",
    seeAll_9ff264: "See all →",
    noCompletedOrApprovedInspectionCyclesAre_58ad5b: "No completed or approved inspection cycles are recorded.",
    noLinkedAssetsYet_f0421d: "No linked assets yet.",
    viewRelationships_855c37: "View relationships →",
    noOpenJobsOrInprogressInspectionsAre_c07385: "No open jobs or in-progress inspections are recorded.",
    sharedContactsAndQRScannersReportIssues_ece9d2: "Shared contacts and QR scanners report issues straight into your work queue.",
    addArticle_2f4275: "Add article",
    shareLibrary_4057e3: "Share library",
    signInToSeeThisKnowledge_4eaa03: "Sign in to see this knowledge",
    yourSessionHasExpiredSoTheseArticles_f87fa2: "Your session has expired, so these articles cannot be loaded. Sign in again to continue.",
    couldnrsquotLoadKnowledge_da1c79: "Couldn't load knowledge",
    tryLoadingKnowledgeAgain_1b6aa1: "Try loading knowledge again",
    refineArticles_d1b417: "Refine articles",
    kind_e00ac2: "Kind",
    egElectrical_0b7339: "e.g. electrical",
    egBoilerAnnual_18e665: "e.g. boiler, annual",
    pinnedOnly_bd8de5: "Pinned only",
    egBoilerResetProcedure_91545f: "e.g. Boiler reset procedure",
    uRL_0e2d9b: "URL",
    https_1a6627: "https://…",
    content_4f9be0: "Content",
    writeStepsAnswerOrNotes_974f8b: "Write steps, answer, or notes…",
    chooseFile_3fd558: "Choose file…",
    setTitlecategoryAboveBeforeUploadingOptional_cea97d: "Set title/category above before uploading (optional).",
    shortSummaryOrContext_239731: "Short summary or context",
    pinned_f93121: "Pinned",
    shareKnowledge_a28e38: "Share knowledge",
    shareWith_134bfa: "Share with",
    chooseContactToShareWith_f8c887: "Choose contact to share with",
    noEmailOnContact_2730d7: "No email on contact",
    chooseContact_4a3f8f: "Choose contact…",
    createLinkCopy_460e24: "Create link & copy",
    activeShares_8d41b3: "Active shares",
    revokeShare_1d9e95: "Revoke share",
    addAtLeastTwoAssetsInThis_92640d: "Add at least two assets in this scope to create links between them.",
    startInWork_47c346: "Start in Work",
    propertyCategory_dfd0bc: "Property category",
    propertySubtype_7092d7: "Property subtype",
    vehicleClass_1807bf: "Vehicle class",
    equipmentClass_f1c8f7: "Equipment class",
    domain_9b1091: "Domain",
    furnished_8ab38e: "Furnished",
    operatingContext_c28bb5: "Operating context",
    usageType_0193f0: "Usage type",
    mounting_26ae06: "Mounting",
    safetyClass_c2825e: "Safety class",
    environment_d443a1: "Environment",
    riskTags_391936: "Risk tags",
    otherAssetCategory_c3e627: "Other asset category",
    propertySystems_2983a3: "Property systems",
    conditionFlags_0fd793: "Condition flags",
    transmission_ace17e: "Transmission",
    lastServiceDate_6a44ff: "Last service date",
    roadworthinessExpiry_a32510: "Roadworthiness expiry",
    insuranceExpiry_5788c0: "Insurance expiry",
    capacityUnit_f595ba: "Capacity unit",
    useStructuredOptionSetsSoTemplateRecommendation_a4913e: "Use structured option sets so checklist recommendation and generation stay clean.",
    addOneOrMoreRelationshipsNowOr_bdce2c: "Add one or more relationships now, or leave empty to keep this asset standalone.",
    noDraftRelationshipsAddedYet_0698d2: "No draft relationships added yet.",
    chooseTheRelatedAsset_35789f: "Choose the related asset",
    fromThisAsset_48c52c: "From this asset",
    toThisAsset_f70126: "To this asset",
    relationshipCriticality_1a33c6: "Relationship criticality",
    riskPropagationMode_720d7e: "Risk propagation mode",
    propagationMode_fa66d1: "Propagation mode",
    noAssetsToVisualizeYet_c42bdd: "No assets to visualize yet.",
    links_014bcd: "Links",
    display_574ff9: "Display",
    viewAffectedWork_acb250: "View affected work →",
    relationshipTypes_558b4b: "Relationship Types",
    clickToEditOrRemove_8526e9: "Click to edit or remove",
    understandingRisk_2e43d7: "Understanding risk",
    whatRaisesOrLowersLikelihood_622b19: "What raises or lowers likelihood",
    whatRaisesOrLowersImpact_767cc7: "What raises or lowers impact",
    noRelationshipbasedAdjustmentsToShow_47ffe9: "No relationship-based adjustments to show.",
    likelihoodMixScoreWeightContribution_2582ca: "Likelihood mix (score × weight = contribution)",
    impactMix_ec0686: "Impact mix",
    rawWeightedValues_f4522d: "Raw weighted values",
    assetRisk_54b50c: "Asset risk",
    "55Matrix_f6b01d": "5×5 matrix",
    topDrivers_f8f235: "Top drivers",
    whyThisRiskScore_6c74da: "Why this risk score?",
    mo_e9e0ce: "/mo",
    aW_073d87: "AW",
    suggestedNextStep_4a96db: "Suggested next step: ",
    complianceAndAudit_d16087: "Compliance and audit",
    moreInBreakdown_3e1121: "+ more in breakdown",
    opensMapsWithDirectionsFromYourLocation_44a789: "Opens maps with directions from your location",
    closeDocument_7866c7: "Close document",
    openingFile_c515cb: "Opening file",
    notDisplayingOpenItInYourBrowser_a5761f: "Not displaying? Open it in your browser.",
    openInBrowser_052269: "Open in browser",
    noInappPreview_37df05: "No in-app preview",
    previewUnavailable_36d31d: "Preview unavailable",
    thisDocumentCouldNotBeDisplayedHere_e78b36: "This document could not be displayed here. Use “Open in browser” below to read it.",
    theDocumentRendererIsUnavailableInThis_3dc0a5: "The document renderer is unavailable in this build. Use “Open in browser” below.",
    loadingDocument_77cac7: "Loading document",
    couldNotReadThisFile_fce43e: "Could not read this file",
    theFileCouldNotBeDownloadedUse_fd63bb: "The file could not be downloaded. Use “Open in browser” below, or try again when you have a stable connection.",
    loadingVideo_c18920: "Loading video",
    workArrivesFromTheFieldAQR_d69f49: "Work arrives from the field, a QR scan or a requester — then loops through to review.",
    howAssetWRXWorks_a6652b: "How AssetWRX works",
    theEverydayLoopEndToEndTap_f41cec: "The everyday loop, end to end. Tap any stage to jump in.",
    howToGetTheMostOutOf_6ecde4: "How to get the most out of AssetWRX — by task, with interactive walkthroughs.",
    loadingInspectionDetails_07441a: "Loading inspection details...",
    weCouldntLoadThisInspection_0d9c6e: "We couldn't load this inspection",
    loadingChecklist_6d4b18: "Loading checklist…",
    inspectionDetails_f70991: "Inspection details",
    thisInspectionWasCreatedFromARequest_62e54f: "This inspection was created from a request and remains linked to its request timeline.",
    openSourceRequest_847fb2: "Open source request",
    clearSkip_6abff6: "Clear skip",
    clearsSkipSoYouCanAnswerThis_fdd91c: "Clears skip so you can answer this item.",
    useYesNoPassFailStarsOrSkipBelow_c5d2c7: "Use Yes/No, Pass/Fail, stars, or Skip below the title to answer.",
    unskipItem_a158ab: "Unskip item",
    unskip_cde472: "Unskip",
    skipItem_cb392b: "Skip item",
    opensAShortFormYouCanSkip_8bc9f3: "Opens a short form. You can skip with or without a note.",
    notConfirmed_b9e09a: "Not confirmed",
    evidenceRecommendedAddAPhotoOfThe_f5d5bd: "Evidence recommended — add a photo of the issue.",
    noVideosRecorded_803350: "No videos recorded",
    upTo3Photos1VideoMax_382f91: "Up to 3 photos · 1 video, max 20s",
    inspectionAttachments_4eccaa: "Inspection attachments",
    skipTheCurrentGroupOfItemsBecause_22712a: "Skip the current group of items because none apply",
    skipThisGroup_348a6d: "Skip this group",
    keyboardShortcuts_266695: "Keyboard shortcuts",
    closeKeyboardShortcuts_b87b09: "Close keyboard shortcuts",
    requestConversation_7db6bd: "Request conversation",
    retryExport_f58f53: "Retry export",
    completedTheWork_099993: "Completed the work",
    notSharedYetUseShareAboveTo_81bebb: "Not shared yet — use Share above to send this report to a contact.",
    couldNotGenerateReport_fb1286: "Could not generate report",
    showAllDetails_c5a7a8: "Show all details",
    neededBeforeCompletion_304a39: "Needed before completion",
    completionProgress_e2e2b3: "Completion progress",
    latestUpdate_749cd8: "Latest update",
    noUpdatesYet_24f53d: "No updates yet.",
    beforeYouSubmit_ede7c3: "Before you submit:",
    invoiceExtraction_b8d23c: "Invoice extraction",
    reviewExtractedItems_9649fe: "Review extracted items",
    noLineItemsDetectedTryAClearer_7ebd61: "No line items detected. Try a clearer photo or add items manually.",
    removeLineItem_68fb55: "Remove line item",
    useCalculated_7192f0: "Use calculated",
    leaveBlankToRecordAs0Enter_74cafa: "Leave blank to record as 0. Enter the full amount for this job.",
    addLineItem_2932d8: "Add line item",
    invoiceOrReceipt_bcd947: "Invoice or receipt",
    attached_8e632c: "Attached",
    pDFImageOrWordDocument_812ab0: "PDF, image, or Word document.",
    whyThisJobWasSuggested_e32a41: "Why this job was suggested",
    what3words_881ff5: "what3words",
    filledcountsoap_1a66d3: "///filled.count.soap",
    nothingToChooseFromYet_978c4e: "Nothing to choose from yet.",
    reportNotAvailable_c048c4: "Report not available",
    thisLinkMayBeInvalidOrThe_0e72cd: "This link may be invalid or the report is no longer shared.",
    itemsChecked_34daa1: "Items checked",
    needAttention_46d04d: "Need attention",
    seeTheFullReport_d02b8d: "See the full report",
    signInToRequestAccess_2e7a0e: "Sign in to request access",
    requestSentTheTeamManagingThisAsset_56c7e0: "Request sent. The team managing this asset will review it — you'll be notified when they respond.",
    theTeamManagingThisAssetDeclinedThis_072c77: "The team managing this asset declined this request. Contact them directly if you believe you should have access.",
    yourRelationshipToThisAsset_088c6c: "Your relationship to this asset",
    selectARole_de9e0a: "Select a role",
    anythingToAddOptional_d0e207: "Anything to add? (optional)",
    egImTheTenantAtThisProperty_900046: "e.g. I'm the tenant at this property",
    staySignedIn_e5f5f7: "Stay signed in",
    signatureCanvas_b150c4: "Signature canvas",
    opensTheTimeSelector_03fd5a: "Opens the time selector",
    rowDensity_0a44a7: "Row density",
    pullingTheLatestActivityForThisRequest_3eb3bd: "Pulling the latest activity for this request.",
    selectARequest_e23d7c: "Select a request",
    chooseARequestToSeeItsDetail_17587d: "Choose a request to see its detail and activity.",
    caseTimeline_ea3757: "Case timeline",
    addACheck_a948e9: "Add a check",
    cancelAddingACheck_a8ca4e: "Cancel adding a check",
    searchChecklists_bf435d: "Search checklists…",
    buildANewChecklistToUseAs_eeb155: "Build a new checklist to use as a check",
    buildANewChecklist_4597c6: "Build a new checklist",
    requireThisCheckBeforeTheJobCan_75004c: "Require this check before the job can be completed",
    requiredToCompleteTheJob_93fe15: "Required to complete the job",
    offByDefaultARequiredCheckBlocks_83f24c: "Off by default. A required check blocks completion until it is finished.",
    sendACalendarInviteToSomeoneAt_1ef692: "Send a calendar invite to someone at the asset",
    optionalTheyllGetAnEmailCalendarInvite_f3c0fa: "Optional — they’ll get an email calendar invite (.ics) for this time slot.",
    inviteToCalendar_f4347a: "Invite to calendar",
    thisCheckHasNoSteps_3d81af: "This check has no steps",
    checkChangedTitle: "Someone else updated this check",
    checkChangedBody: "Their answers are shown now. Answer again where you need to.",
    theTemplateItCameFromIsEmpty_dee3b8: "The checklist it came from is empty. Edit the checklist to add steps, then attach it again.",
    savedOnThisDeviceWillSyncWhen_3db4e0: "Saved on this device — will sync when you’re back online",
    prepareWork_8aa4da: "Prepare work",
    loadingWorkContext_c860da: "Loading work context",
    reopenCase_a32ef8: "Reopen the request",
    reopen_61e05d: "Reopen",
    conversation_2a20c7: "Conversation",
    writeAReply_dd081e: "Write a reply…",
    escalated_aff666: "Escalated",
    closeWithoutAResponse_3bf706: "Close without a response",
    closeWithoutResponse_6c6096: "Close without response",
    automateThisChase_49d451: "Automate this chase",
    couldntLoadYourTemplates_b41115: "Couldn’t load your checklists",
    upcomingVisits_ecb005: "Upcoming visits",
    theTeamHasPlannedWorkHereAnd_78e2ed: "The team has planned work here and asked you to confirm someone can be there.",
    whoWillLetUsIn_66de4a: "Who will let us in?",
    noOneNeeded_4ab28b: "No one needed",
    theyaposllBeAskedToConfirmTheVisit_d8cb82: "They'll be asked to confirm the visit time or suggest a different one.",
    sort_8b335a: "Sort:",
    egReplaceWornBelt_49815f: "e.g. Replace worn belt",
    tryLoadingChecklistsAgain_bd84f3: "Try loading checklists again",
    noChecklistMatchesThisAssetTypeYet_d47d21: "No checklist matches this asset type yet.",
    createAChecklist_02f012: "Create a checklist",
    createANewChecklistTemplate_ec189b: "Create a new checklist",
    newChecklist_d80825: "New checklist",
    when_b2028c: "When?",
    chooseWhenThisWorkShouldHappen_78b867: "Choose when this work should happen",
    later_56e2f5: "Later",
    howLongWillItTake_5c9649: "How long will it take?",
    suggestedTimes_aa2e2b: "Suggested times",
    noSlotFitsBeforeTheDueDate_8c442c: "No slot fits before the due date — the work needs more time, another assignee, or a moved deadline.",
    howToRunIt_5809c8: "How to run it",
    endsOptional_92d6de: "Ends (optional)",
    maxTimes_e58588: "Max times",
    advanceTheSeries_2f1cf7: "Advance the series",
    skipARunIfThePreviousOne_1b5907: "Skip the next one if the last one is still open",
    remindMe_25df3f: "Remind me",
    anythingTheInspectorShouldKnow_af9eeb: "Anything the inspector should know",
    assignTo_cc7907: "Assign to",
    theContractorYouAwardOrHandThis_9cbde2: "The contractor you award or hand this job to. Picking one here does not assign it — the award does.",
    checks_5098dd: "Checks",
    optionalAPrecheckConfirmsItIsSafe_db4e1f: "Optional. A precheck confirms it is safe to start; a postcheck confirms the work before leaving. Checks added here are required, so the job cannot be completed until they are done.",
    analysingOnDevice_54be55: "Analysing on device…",
    codes_199993: "Codes",
    meterReadings_a3c12c: "Meter readings",
    dates_842b7b: "Dates",
    detected_74fb2c: "Detected",
    extractedText_5ea632: "Extracted text",
    noInformationWasExtractedOnDevice_80b803: "No information was extracted on device.",
    enhancingWithAI_8078cd: "Enhancing with AI…",
    aIEnhancementWillBeAvailableWhenYoure_ff5c7e: "AI enhancement will be available when you’re back online. Everything read on this device is saved.",
    summariseJourney_846b25: "Summarise journey",
    loadedMatchesMoreAssetsAreAvailable_b38944: "{{value1}} loaded matches. More assets are available.",
    showing_6ec0cc: "Showing: {{value1}}",
    organisations_b83a9b: "Organisations{{value1}}",
    openJobs_31f2a1: "Open jobs{{value1}}",
    viewAll_f6220a: "View all · {{value1}}",
    latest_a94fea: "Latest: {{value1}}",
    previous_b3f133: "Previous: {{value1}}",
    risk_ad0435: "Risk: {{value1}} ({{value2}})",
    health_c90470: "Health: {{value1}} ({{value2}})",
    compliance_49ba65: "Compliance: {{value1}} ({{value2}})",
    confidenceReviewBeforeApplying_a8e435: "{{value1}} {{value2}} confidence. Review before applying.",
    confidenceReviewBeforeApplying_050de9: "{{value1}} {{value2}}% confidence. Review before applying.",
    itWillBeCreatedAsCommissionIt_d1903a: "It will be created as {{value1}}. Commission it from the asset page when it is ready — an inspection, then any jobs it raises.",
    upToPhotosOptionalTapThePreview_750506: "Up to {{value1}} photos — optional. Tap the preview or use the buttons below.",
    tapToAddAnother_f06704: "Tap to add another ({{value1}}/{{value2}})",
    upToPhotosTotal_59c8b8: "Up to {{value1}} photos total",
    headsUpAlreadyUsesThisIDSerial_108120: "Heads up: “{{value1}}” already uses this ID / Serial.",
    mo_8759d1: "{{value1}}mo",
    upToPhotosOptionalSameAsWhen_a03894: "Up to {{value1}} photos (optional). Same as when creating an asset — tap the preview or use Camera / Gallery to add more.",
    addAnotherPhoto_634f18: "Add another photo ({{value1}}/{{value2}})",
    groups_104467: "Groups: {{value1}}",
    items_b74542: "Items: {{value1}}",
    required_40bdfd: "Required: {{value1}}",
    conditionalRules_047d88: "Conditional rules: {{value1}}",
    currentVersionIsVSavingFromThis_07a9f2: "Current version is v{{value1}}. Saving from this editor will create v{{value2}}.",
    categories_5b1690: "Categories: {{value1}}",
    depth_5fb610: "Depth: {{value1}}",
    evidence_6674e1: "Evidence: {{value1}}",
    objectiveLengthChars_a7cb1d: "Objective length: {{value1}} chars",
    runID_27348d: "Run ID: {{value1}}",
    estimatedDurationMin_a210a3: "Estimated duration: {{value1}} min",
    responseDeadline_834634: "Response deadline: {{value1}}",
    targetStart_cb37f8: "Target start: {{value1}}",
    targetEnd_f9f809: "Target end: {{value1}}",
    estimatedBudget_070f47: "Estimated budget: {{value1}} {{value2}}",
    attachedPhotos_740082: "Attached photos · {{value1}}",
    category_5e6549: "Category: {{value1}}",
    urgency_3bf5ac: "Urgency: {{value1}}",
    dueDate_279007: "Due date: {{value1}}",
    type_45c583: "Type: {{value1}}",
    pleaseRespondBy_ec61f2: "Please respond by {{value1}}",
    playVideo_dbbc47: "Play video {{value1}}",
    yourReason_882f62: "Your reason: \"{{value1}}\"",
    twofactorOfEnrolled_3402d7: "Two-factor: {{value1}} of {{value2}} enrolled",
    currencyCommunication_43aa12: "Currency: {{value1}} · Communication: {{value2}}",
    errorsInView_5612eb: "Errors in view: {{value1}}",
    when_f062b4: "When: {{value1}}",
    locale_469d05: "Locale: {{value1}}",
    credits_ae86ee: "Credits: {{value1}} ({{value2}})",
    entity_1fba91: "Entity: {{value1}}",
    step_0d893e: "Step {{value1}}",
    lastSuccessfulSyncLastFailedSyncNone_8b8bea: "Last successful sync: {{value1}} · Last failed sync: None recorded",
    credentialSecretHiddenAfterCreationRotatedRevoked_326665: "Credential: secret hidden after creation · rotated {{value1}} · revoked {{value2}}",
    status_ac4b0a: "Status: {{value1}}",
    lastSuccessfulSync_d6b22a: "Last successful sync: {{value1}}",
    lastFailedSync_e7a87b: "Last failed sync: {{value1}}",
    logsHistory_117ea0: "Logs / history: {{value1}}",
    suggested_bfc937: "Suggested: {{value1}} · {{value2}}%",
    row_69394c: "Row {{value1}}",
    updated_3ada36: "Updated: {{value1}}",
    newSitesCreated_a610d0: "New sites created: {{value1}}",
    skippedByConflictPolicy_e92870: "Skipped by conflict policy: {{value1}}",
    failed_1c734b: "Failed: {{value1}}",
    pOST_39bb77: "POST {{value1}}",
    credentialTokenRotated_3254bf: "Credential: {{value1}} token {{value2}}...{{value3}} · rotated {{value4}}",
    invocations_1e09a7: "{{value1}} invocations",
    lastSuccess_204f28: "Last success: {{value1}}",
    lastFailure_fe19b0: "Last failure: {{value1}}",
    authTypeHeader_b1a0ff: "Auth type: {{value1}}. Header: {{value2}}.",
    secretState_e4463d: "Secret state: {{value1}}.",
    request_65ee72: "Request: {{value1}}",
    response_7fff2f: "Response: {{value1}}",
    statusRecentAssistantInvocations_a6c770: "Status: {{value1}} • recent assistant invocations: {{value2}}",
    lastInvocation_8b8558: "Last invocation: {{value1}}",
    lastError_e74e5f: "Last error: {{value1}}",
    aHostedMCPEndpointForThisWorkspace_2ee242: "A hosted MCP endpoint for this workspace: {{value1}}",
    toolsAndResourcesEachFilteredByWorkspace_bdcaa8: "{{value1}} tools and {{value2}} resources, each filtered by workspace and service-account scopes.",
    reads_a89270: "Reads: {{value1}}",
    writes_532f15: "Writes: {{value1}}",
    path_676484: "Path: {{value1}}",
    scopes_993717: "Scopes: {{value1}} {{value2}}",
    expiresCreated_8b46c7: "Expires {{value1}} • created {{value2}}",
    preview_36c78a: "Preview: {{value1}}",
    ms_588b6b: "{{value1}} ms • {{value2}}",
    credits_05f92c: "{{value1}} credits",
    checks_05efc2: "{{value1}}{{value2}}% · {{value3}} checks",
    dataQuality_984221: "{{value1}} · {{value2}}% data quality",
    reason_74bb8e: "Reason: {{value1}}",
    showingRequestsFrom_dc8278: "Showing requests from {{value1}}.",
    typeToConfirm_fac0ca: "Type {{value1}} to confirm",
    lastCycles_9f5334: "Last {{value1}} cycles",
    openWork_cc107a: "Open work · {{value1}}",
    tags_6e1f36: "Tags: {{value1}}",
    team_fff0a5: "Team: {{value1}}",
    compliance_89f882: "Compliance · {{value1}}",
    registered_8b441e: "Registered {{value1}}",
    ofCoreFieldsFilled_0f25e0: "{{value1}} of {{value2}} core fields filled",
    stillMissing_f3dd5e: "Still missing: {{value1}}",
    appliedReviewTheFieldsBelowTheySave_866743: "Applied {{value1}} {{value2}} — review the fields below; they save automatically.",
    poor_904815: "{{value1}} poor",
    watch_a1d644: "{{value1}} watch",
    good_aaf5c2: "{{value1}} good",
    unscored_e4e509: "{{value1}} unscored",
    criticality_b7cd47: "{{value1}} criticality · {{value2}}",
    open_a1601a: "{{value1}} open {{value2}}",
    lastInspected_71de34: "Last inspected · {{value1}}",
    rulesCalculated_3cece2: "Rules {{value1}} · Calculated {{value2}}",
    likelihoodImpact_b6a9fb: "Likelihood {{value1}} × Impact {{value2}}",
    "5Weight_d64551": "{{value1}}/5 · {{value2}} · {{value3}}% weight",
    standaloneScoresBeforeLinkAdjustmentLI_1c934f: "Standalone scores before link adjustment: L {{value1}} · I {{value2}}",
    relationshipAdjustmentsAppliedLI_17818d: "Relationship adjustments applied: L {{value1}}{{value2}} · I {{value3}}{{value4}}",
    lRawRoundedIRawRounded_c4c6f6: "L raw {{value1}} → rounded {{value2}}; I raw {{value3}} → rounded {{value4}}",
    rules_4b3591: "Rules {{value1}}{{value2}}",
    skipped_2fd804: "Skipped{{value1}}",
    reportRef_4ee599: "Report ref: {{value1}}",
    completed_57e944: "Completed {{value1}}",
    round_6178c9: "Round {{value1}} · {{value2}}",
    firstShared_249645: "First shared {{value1}}{{value2}}",
    dueBy_d51c85: "Due by {{value1}}",
    scheduledFor_37e8f3: "Scheduled for {{value1}}",
    confidence_615dda: "{{value1}} confidence",
    useExtractedTotalAsActualCost_463a4f: "Use extracted total{{value1}}{{value2}} as actual cost",
    fromQtyUnit_c1c1c3: "From qty × unit: {{value1}}{{value2}}{{value3}}",
    estimate_3a8133: "Estimate: {{value1}}",
    actual_e5762d: "Actual: {{value1}}",
    vsEstimate_5939a7: "vs estimate: {{value1}}{{value2}}{{value3}} ({{value4}}{{value5}}%)",
    materialsSubtotal_f5bcb3: "Materials subtotal: {{value1}}{{value2}}",
    inspected_517599: "Inspected {{value1}}",
    theFullReportFindingsPhotosRecommendationsAnd_e1e094: "The full report — findings, photos, recommendations and any costs — is shared only with approved people. {{value1}}",
    selected_deace8: "{{value1}} selected",
    signedBy_06a094: "Signed by {{value1}}",
    tapSummariseJourneyToTryAgain_f327c1: "{{value1}} Tap “Summarise journey” to try again.",
  },
  close: "Close",
  back: "Back",
  next: "Next",
  detailTabs: {
    scrollForward: "Show more tabs",
    scrollBack: "Show earlier tabs",
  },
  freePeriod: {
    until: "Free until {{date}}. Choose a plan to keep your workspace working after that.",
    ended: "Your free period has ended and your workspace is read-only. Choose a plan to keep working. Nothing has been deleted.",
  },
  aiReport: {
    link: "Report",
    title: "Report this AI response",
    body: "Tell us what is wrong with it. We keep the text you were shown so we can check it.",
    offensive: "Offensive",
    harmful: "Harmful or unsafe",
    wrong: "Wrong or misleading",
    cancel: "Cancel",
    sentTitle: "Report sent",
    sentBody: "Thank you. We review every report.",
    failedTitle: "Could not send the report",
  },
  collaboratorUpgrade: {
    contractorTitle: "Run your own jobs and clients",
    contractorBody: "Keep your own customers, jobs and invoices here, with your own AI credits. The work you do for others stays as it is.",
    requesterTitle: "Keep your own maintenance record",
    requesterBody: "Track the property and equipment you look after yourself, with its jobs, inspections and documents. What is shared with you stays as it is.",
    recipientTitle: "Inspect your own assets like this",
    recipientBody: "Run inspections and reports like this one on your own assets. What is shared with you stays as it is.",
    otherTitle: "Manage your own assets",
    otherBody: "Set up a workspace of your own for your own assets and work. What you do for others stays as it is.",
    cta: "See plans",
    freeReady: "Your workspace is ready. Add your first asset from the + button.",
  },
  aiCost: {
    included: "Included by {{host}} · {{n}} credits left this month",
    includedUsed: "{{host}} includes no more AI this month. You can use your own credits.",
    generateFailed: "The draft could not be written. Try again, or create the checklist yourself.",
    buy: "Buy credits",
    onWeb: "Credits are bought from AssetWRX on the web, or arrive with your monthly credits.",
    buyHint: "Buy a credit pack to continue, or wait for your monthly credits.",
    askAdmin: "Ask a workspace owner or admin to buy credits, or wait for your monthly credits.",
    askNamed: "Ask {{name}} to buy credits, or wait for your monthly credits.",
    shortUnknown: "There are not enough AI credits left for this.",
    short: "Not enough credits: this needs {{n}}, {{balance}} left.",
    hint: "AI credits used: {{n}} · Available: {{balance}}",
  },
  aiGenerate: {
    discard: "Discard",
    keep: "Keep it",
    discardBody: "It will not be saved. You can write a new one from the form.",
    discardTitle: "Discard this draft?",
    saveDraft: "Save draft",
    unsavedMessage: "Your AI checklist draft has not been saved yet. Leave and lose it?",
    leaveReviewTitle: "Leave review?",
    savedTitle: "Checklist saved",
    feedbackFailedBody: "Failed to record feedback. The checklist was saved successfully.",
    goToTemplate: "Go to checklist",
    saveFailed: "Failed to save checklist.",
    leaveReviewBody: "Your draft will not be saved. Discard it from the review screen to record feedback.",
    stay: "Stay",
    moreOptionsSummary: "Time, photos, order and style",
    moreOptions: "More options",
    baseLabel: "Copy the style of (optional)",
    goal: {
      fail_only_evidence: "Photos only for failures",
      physical_flow: "The order you walk round",
      compliance: "Meeting the rules",
    },
    goalLabel: "Also arrange it for (optional)",
    evidence: {
      always: "On every item",
      optional: "When the inspector wants",
      fail_only: "Only when something fails",
    },
    evidenceLabel: "When to ask for photos",
    depth: {
      detailed: "Thorough",
      standard: "Standard",
      lite: "Quick check",
    },
    depthLabel: "How detailed",
    noAsset: "No particular asset",
    basePlaceholder: "Choose a checklist to copy its style",
    baseSelected: "Selected",
    baseNone: "None",
  },
  aiDisclosure: {
    title: "AI features use Google",
    body: "AssetWRX sends the photos and text involved to Google (Gemini) to do this. Google does not train on them. Evidence photos you keep from Vision may improve WRX Vision unless your workspace owner turns that off. Details in Profile → Privacy & data.",
    allow: "Allow",
    notNow: "Not now",
    declined: "AI was not used. You can allow it the next time you use an AI feature.",
  },
  sessionExpiryBanner: {
    expiresIn_one: "Your session will expire in {{count}} minute.",
    expiresIn_other: "Your session will expire in {{count}} minutes.",
  },
  offlineStrip: {
    offline: "Offline · changes sync when you reconnect",
    offlineQueued_one: "Offline · {{count}} change waiting to sync",
    offlineQueued_other: "Offline · {{count}} changes waiting to sync",
    syncing_one: "Syncing {{count}} change…",
    syncing_other: "Syncing {{count}} changes…",
    queued_one: "{{count}} change waiting to sync",
    queued_other: "{{count}} changes waiting to sync",
  },
  photoLimit: {
    title: "Photo limit reached",
    body_one: "You can attach up to {{count}} photo here. Remove one to add another.",
    body_other: "You can attach up to {{count}} photos here. Remove one to add another.",
  },
  mapBoundary: {
    start: "Tap the corners of this site",
    more_one: "Tap at least {{count}} more corner",
    more_other: "Tap at least {{count}} more corners",
    adjust: "Drag a corner to adjust, or save",
  },
  importSites: {
    listSeparator: ", ",
    moreNames_one: ", +{{count}} more",
    moreNames_other: ", +{{count}} more",
    confirmTitle_one: "Create up to {{count}} new site?",
    confirmTitle_other: "Create up to {{count}} new sites?",
    confirmBody_one: "This import will create up to {{count}} new site and link assets to it:\n{{names}}{{more}}\n\nExisting sites are reused where the name matches. Go back and fix the sheet first if any of these are duplicates or typos.",
    confirmBody_other: "This import will create up to {{count}} new sites and link assets to them:\n{{names}}{{more}}\n\nExisting sites are reused where the name matches. Go back and fix the sheet first if any of these are duplicates or typos.",
    backToPreview: "Back to preview",
    createAndImport: "Create & import",
    actionCreate: "create",
    actionUpdate: "update",
    actionSkip: "skip",
    actionError: "error",
    calloutNew_one: "Up to {{count}} new site will be created",
    calloutNew_other: "Up to {{count}} new sites will be created",
    calloutMatched: "Sites matched by name",
    linkExisting_one: "Assets link to {{count}} existing site matched by name.",
    linkExisting_other: "Assets link to {{count}} existing sites matched by name.",
    matchedCaseInsensitive: "Names are matched to existing sites (case-insensitive).",
    reuseNote: " Existing sites are reused where the name matches — you confirm new sites before importing.",
  },
  attachmentsPanel: {
    title: 'Attachments',
    all: 'All',
    empty: 'Nothing attached yet.',
    kind: { photo: 'Photos', video: 'Videos', audio: 'Voice', document: 'Files' },
    source: {
      fallback: 'Attachment',
      'job.completion_photo': 'Completion photo',
      'job.completion_video': 'Completion video',
      'job.completion_voice_note': 'Completion voice note',
      'job.receipt': 'Receipt',
      'job.activity_attachment': 'Activity attachment',
      'inspection.item_photo': 'Inspection photo',
      'inspection.item_video': 'Inspection video',
      'inspection.item_voice_note': 'Inspection voice note',
    },
  },
};
